export const chinaBorder= {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 100000,
			"name": "中华人民共和国",
			"center": [116.3683244, 39.915085],
			"centroid": [104.113164, 37.570667],
			"childrenNum": 34,
			"level": "country",
			"parent": {
				"adcode": null
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[123.388512, 39.74742],
						[123.389744, 39.763984],
						[123.350939, 39.750641],
						[123.274563, 39.753862],
						[123.270251, 39.714743],
						[123.286882, 39.704154],
						[123.253005, 39.689879],
						[123.215433, 39.696786],
						[123.212969, 39.665928],
						[123.166774, 39.674219],
						[123.146448, 39.647037],
						[123.103332, 39.676983],
						[123.010941, 39.655331],
						[123.021412, 39.64335],
						[122.978912, 39.616156],
						[122.972753, 39.594946],
						[122.941956, 39.604629],
						[122.860652, 39.604629],
						[122.847101, 39.581571],
						[122.808913, 39.559889],
						[122.682645, 39.514658],
						[122.649385, 39.516505],
						[122.637066, 39.488799],
						[122.581631, 39.464316],
						[122.532972, 39.419947],
						[122.489856, 39.403764],
						[122.412864, 39.411625],
						[122.366668, 39.390815],
						[122.366053, 39.370461],
						[122.30877, 39.346399],
						[122.274893, 39.322329],
						[122.242865, 39.267678],
						[122.160329, 39.238019],
						[122.117213, 39.213911],
						[122.123988, 39.172631],
						[122.167104, 39.158711],
						[122.127684, 39.144788],
						[122.088264, 39.112291],
						[122.048228, 39.101146],
						[122.071634, 39.074204],
						[122.061778, 39.060264],
						[122.013735, 39.073275],
						[121.963228, 39.030053],
						[121.913953, 39.0598],
						[121.929352, 39.024939],
						[121.864062, 39.037026],
						[121.855439, 39.025869],
						[121.905946, 38.997503],
						[121.920728, 38.969591],
						[121.863446, 38.942598],
						[121.804932, 38.970986],
						[121.790149, 39.022614],
						[121.756889, 39.025869],
						[121.73841, 38.998898],
						[121.671273, 39.010059],
						[121.66265, 38.966333],
						[121.618918, 38.950046],
						[121.655874, 38.946788],
						[121.719316, 38.920252],
						[121.708845, 38.872744],
						[121.675585, 38.86156],
						[121.618302, 38.862492],
						[121.564715, 38.874607],
						[121.509897, 38.817743],
						[121.399028, 38.812613],
						[121.359608, 38.822406],
						[121.302325, 38.78976],
						[121.259825, 38.786495],
						[121.198848, 38.721623],
						[121.13787, 38.723023],
						[121.112, 38.776231],
						[121.12863, 38.799089],
						[121.110768, 38.862026],
						[121.129862, 38.879266],
						[121.094138, 38.894173],
						[121.08921, 38.922115],
						[121.128014, 38.958888],
						[121.180369, 38.959819],
						[121.204391, 38.941202],
						[121.275224, 38.971917],
						[121.341129, 38.980757],
						[121.317108, 39.012384],
						[121.370695, 39.060264],
						[121.431057, 39.027263],
						[121.508049, 39.034237],
						[121.581962, 39.075598],
						[121.599208, 39.098824],
						[121.562252, 39.127149],
						[121.590585, 39.154999],
						[121.642324, 39.11972],
						[121.605983, 39.080708],
						[121.631853, 39.077921],
						[121.68236, 39.117863],
						[121.639244, 39.166136],
						[121.604136, 39.166136],
						[121.586889, 39.193506],
						[121.591201, 39.228748],
						[121.631237, 39.22643],
						[121.589353, 39.263044],
						[121.623846, 39.285745],
						[121.672505, 39.275554],
						[121.667577, 39.310754],
						[121.70207, 39.326496],
						[121.72486, 39.364447],
						[121.621382, 39.326033],
						[121.562252, 39.322792],
						[121.51544, 39.286672],
						[121.464933, 39.30103],
						[121.466781, 39.320014],
						[121.435984, 39.329736],
						[121.432904, 39.357506],
						[121.35468, 39.377863],
						[121.324499, 39.371386],
						[121.307869, 39.391277],
						[121.270296, 39.374162],
						[121.245659, 39.389427],
						[121.246891, 39.421334],
						[121.304173, 39.48187],
						[121.286927, 39.507271],
						[121.268449, 39.482794],
						[121.224717, 39.519275],
						[121.226565, 39.554814],
						[121.263521, 39.589873],
						[121.299246, 39.606013],
						[121.325731, 39.601402],
						[121.450151, 39.624914],
						[121.451999, 39.658095],
						[121.482796, 39.659478],
						[121.502506, 39.703233],
						[121.45939, 39.747881],
						[121.487107, 39.760303],
						[121.472325, 39.802155],
						[121.530223, 39.851334],
						[121.541926, 39.874302],
						[121.572107, 39.865116],
						[121.626925, 39.882569],
						[121.699606, 39.937196],
						[121.76428, 39.933525],
						[121.779062, 39.942702],
						[121.796309, 39.999116],
						[121.824642, 40.025701],
						[121.910257, 40.072887],
						[121.956453, 40.133311],
						[121.995257, 40.128277],
						[122.003264, 40.172191],
						[121.98109, 40.173106],
						[121.950293, 40.204194],
						[121.940438, 40.242121],
						[122.02667, 40.244862],
						[122.039605, 40.260391],
						[122.040221, 40.322017],
						[122.079641, 40.332967],
						[122.110438, 40.315629],
						[122.138155, 40.338897],
						[122.111054, 40.348932],
						[122.135691, 40.374925],
						[122.152322, 40.357597],
						[122.198517, 40.382219],
						[122.186814, 40.422779],
						[122.229314, 40.424146],
						[122.250872, 40.445555],
						[122.241633, 40.465137],
						[122.278589, 40.482891],
						[122.244712, 40.485167],
						[122.245944, 40.519752],
						[122.150474, 40.588413],
						[122.133843, 40.614313],
						[122.148626, 40.671983],
						[122.122141, 40.657457],
						[122.06609, 40.64883],
						[122.025438, 40.674253],
						[121.951525, 40.680607],
						[121.936127, 40.711462],
						[121.934279, 40.79805],
						[121.883772, 40.802127],
						[121.84312, 40.831567],
						[121.816019, 40.894931],
						[121.778446, 40.886787],
						[121.735331, 40.862351],
						[121.732251, 40.846961],
						[121.682976, 40.829755],
						[121.626309, 40.844244],
						[121.576418, 40.837906],
						[121.553013, 40.817528],
						[121.55486, 40.849677],
						[121.526527, 40.85194],
						[121.499426, 40.880001],
						[121.440296, 40.88181],
						[121.355296, 40.892217],
						[121.274608, 40.886335],
						[121.251202, 40.880453],
						[121.23642, 40.851035],
						[121.177906, 40.873665],
						[121.126167, 40.86914],
						[121.076892, 40.815716],
						[121.086747, 40.79805],
						[121.010986, 40.784457],
						[121.00729, 40.807563],
						[120.971566, 40.805751],
						[120.994356, 40.790801],
						[120.980189, 40.766329],
						[120.991276, 40.744115],
						[121.028848, 40.746382],
						[121.032544, 40.709193],
						[120.983269, 40.712822],
						[120.945081, 40.687868],
						[120.861313, 40.684692],
						[120.8299, 40.671076],
						[120.837291, 40.644289],
						[120.822509, 40.59432],
						[120.72827, 40.539311],
						[120.72211, 40.515657],
						[120.693777, 40.505647],
						[120.666676, 40.467413],
						[120.615553, 40.453298],
						[120.617401, 40.41959],
						[120.596459, 40.399084],
						[120.602618, 40.36079],
						[120.537329, 40.325211],
						[120.52193, 40.304676],
						[120.523778, 40.256737],
						[120.491749, 40.20008],
						[120.451097, 40.177679],
						[120.371641, 40.174478],
						[120.273091, 40.127362],
						[120.161606, 40.096239],
						[120.134504, 40.074719],
						[120.092005, 40.077466],
						[119.947259, 40.040364],
						[119.941715, 40.009659],
						[119.91831, 39.989946],
						[119.854252, 39.98857],
						[119.872114, 39.960594],
						[119.842549, 39.956007],
						[119.820375, 39.979399],
						[119.787115, 39.950502],
						[119.726137, 39.940867],
						[119.681789, 39.922511],
						[119.642369, 39.925264],
						[119.620195, 39.904609],
						[119.588166, 39.910576],
						[119.540739, 39.888079],
						[119.520413, 39.840306],
						[119.536427, 39.809052],
						[119.474217, 39.813189],
						[119.366428, 39.734996],
						[119.269726, 39.498497],
						[119.316537, 39.437051],
						[119.317153, 39.4107],
						[119.272805, 39.363521],
						[119.185342, 39.342234],
						[119.121284, 39.281576],
						[119.096031, 39.24219],
						[119.038132, 39.211593],
						[119.023966, 39.187012],
						[118.97777, 39.163352],
						[118.926031, 39.123435],
						[118.890307, 39.118792],
						[118.896466, 39.139683],
						[118.951285, 39.178662],
						[118.920488, 39.171703],
						[118.897082, 39.151286],
						[118.857662, 39.162888],
						[118.814546, 39.138754],
						[118.76096, 39.133648],
						[118.637156, 39.157319],
						[118.578642, 39.130863],
						[118.588497, 39.107648],
						[118.533062, 39.090928],
						[118.570634, 38.999363],
						[118.604511, 38.971452],
						[118.539837, 38.910008],
						[118.491178, 38.909077],
						[118.377845, 38.971917],
						[118.366143, 39.016104],
						[118.319331, 39.009594],
						[118.225092, 39.034701],
						[118.1906, 39.080708],
						[118.162883, 39.136433],
						[118.12531, 39.182838],
						[118.065564, 39.218084],
						[118.056941, 39.219939],
						[118.037231, 39.220402],
						[117.977485, 39.206028],
						[117.96455, 39.172631],
						[117.871543, 39.122506],
						[117.837667, 39.057011],
						[117.855529, 38.957492],
						[117.898029, 38.948649],
						[117.875855, 38.920252],
						[117.847522, 38.855502],
						[117.778536, 38.869016],
						[117.752051, 38.847579],
						[117.64611, 38.828933],
						[117.646725, 38.788827],
						[117.671363, 38.772032],
						[117.740964, 38.753833],
						[117.740964, 38.700141],
						[117.729261, 38.680055],
						[117.65658, 38.66043],
						[117.639334, 38.626776],
						[117.638102, 38.54491],
						[117.68553, 38.539293],
						[117.644878, 38.52759],
						[117.678754, 38.477008],
						[117.72495, 38.457328],
						[117.730493, 38.424985],
						[117.781, 38.373862],
						[117.84629, 38.368232],
						[117.937449, 38.387936],
						[117.957775, 38.376208],
						[117.948536, 38.346644],
						[117.895565, 38.301572],
						[117.896797, 38.279495],
						[118.018753, 38.202409],
						[118.045238, 38.214165],
						[118.112376, 38.210403],
						[118.177665, 38.186417],
						[118.217085, 38.146893],
						[118.331034, 38.12524],
						[118.404331, 38.121003],
						[118.431432, 38.106406],
						[118.44991, 38.124299],
						[118.504729, 38.11394],
						[118.534294, 38.063541],
						[118.552156, 38.05553],
						[118.597736, 38.079088],
						[118.607591, 38.129006],
						[118.626069, 38.138421],
						[118.703677, 38.151129],
						[118.811467, 38.157717],
						[118.908169, 38.139362],
						[118.974075, 38.094162],
						[119.001792, 37.99613],
						[119.110813, 37.921577],
						[119.12806, 37.847892],
						[119.12806, 37.814332],
						[119.154545, 37.806294],
						[119.217371, 37.810077],
						[119.225378, 37.752844],
						[119.275269, 37.739594],
						[119.275885, 37.717347],
						[119.246936, 37.698409],
						[119.133603, 37.705511],
						[119.080016, 37.696514],
						[119.02027, 37.6572],
						[118.988857, 37.620709],
						[118.939582, 37.527268],
						[118.942662, 37.497361],
						[119.001176, 37.31862],
						[119.03998, 37.30434],
						[119.054147, 37.254816],
						[119.084328, 37.239572],
						[119.091103, 37.257674],
						[119.12806, 37.254816],
						[119.136683, 37.230995],
						[119.204436, 37.280058],
						[119.190885, 37.25958],
						[119.2069, 37.223371],
						[119.298675, 37.197156],
						[119.301138, 37.139452],
						[119.327624, 37.115595],
						[119.361501, 37.125616],
						[119.428022, 37.125616],
						[119.489616, 37.134681],
						[119.576463, 37.127524],
						[119.678709, 37.158056],
						[119.698419, 37.127047],
						[119.744615, 37.135158],
						[119.83023, 37.225754],
						[119.865339, 37.233854],
						[119.89244, 37.263866],
						[119.883201, 37.311004],
						[119.837006, 37.346695],
						[119.843781, 37.376662],
						[119.926933, 37.386649],
						[119.949723, 37.419927],
						[120.010085, 37.442263],
						[120.064903, 37.448915],
						[120.086461, 37.465067],
						[120.144359, 37.481691],
						[120.222584, 37.532963],
						[120.246605, 37.556689],
						[120.208417, 37.588469],
						[120.215192, 37.621183],
						[120.272475, 37.636824],
						[120.269395, 37.658622],
						[120.22012, 37.671886],
						[120.227511, 37.693673],
						[120.367945, 37.697935],
						[120.454793, 37.757576],
						[120.517619, 37.750005],
						[120.590915, 37.7642],
						[120.634031, 37.796364],
						[120.656821, 37.793054],
						[120.733197, 37.833714],
						[120.839139, 37.82426],
						[120.845298, 37.826623],
						[120.874863, 37.833241],
						[120.940769, 37.819533],
						[120.943233, 37.785486],
						[120.994356, 37.759468],
						[121.037471, 37.718767],
						[121.136022, 37.723501],
						[121.160043, 37.698882],
						[121.142797, 37.661464],
						[121.161891, 37.646302],
						[121.148956, 37.626397],
						[121.17421, 37.597479],
						[121.217326, 37.582778],
						[121.304789, 37.582778],
						[121.358376, 37.597479],
						[121.349137, 37.635403],
						[121.391021, 37.625449],
						[121.435368, 37.592737],
						[121.395948, 37.589891],
						[121.400876, 37.557638],
						[121.460006, 37.522522],
						[121.477252, 37.475992],
						[121.571491, 37.441313],
						[121.575802, 37.460317],
						[121.635548, 37.494037],
						[121.66573, 37.473617],
						[121.772903, 37.466492],
						[121.923808, 37.473142],
						[121.997721, 37.494512],
						[122.017431, 37.531065],
						[122.075329, 37.540556],
						[122.08888, 37.554316],
						[122.150474, 37.557163],
						[122.163408, 37.519199],
						[122.131996, 37.49926],
						[122.166488, 37.438937],
						[122.194205, 37.456041],
						[122.25272, 37.467917],
						[122.287212, 37.445114],
						[122.281053, 37.430858],
						[122.337103, 37.414223],
						[122.41656, 37.414699],
						[122.487393, 37.43466],
						[122.4954, 37.413748],
						[122.553914, 37.407093],
						[122.641377, 37.428482],
						[122.67587, 37.413273],
						[122.701739, 37.418501],
						[122.714058, 37.392355],
						[122.6925, 37.373809],
						[122.650616, 37.388551],
						[122.607501, 37.364296],
						[122.611196, 37.339558],
						[122.573624, 37.296247],
						[122.567465, 37.25958],
						[122.592718, 37.261485],
						[122.624131, 37.190959],
						[122.573624, 37.176178],
						[122.581015, 37.147562],
						[122.533588, 37.153286],
						[122.484313, 37.128956],
						[122.478769, 37.058784],
						[122.467067, 37.037289],
						[122.494168, 37.033945],
						[122.575472, 37.054485],
						[122.583479, 37.037289],
						[122.544675, 37.004797],
						[122.55761, 36.968467],
						[122.532356, 36.901496],
						[122.48924, 36.886659],
						[122.483081, 36.913938],
						[122.434422, 36.914416],
						[122.457212, 36.868946],
						[122.383915, 36.865595],
						[122.378371, 36.844525],
						[122.344495, 36.828239],
						[122.280437, 36.835904],
						[122.275509, 36.83734],
						[122.220691, 36.848835],
						[122.174495, 36.842609],
						[122.188662, 36.866073],
						[122.175727, 36.894317],
						[122.119677, 36.891924],
						[122.141235, 36.938337],
						[122.124604, 36.944077],
						[122.115981, 36.94025],
						[122.093191, 36.913938],
						[122.051923, 36.904846],
						[122.042684, 36.871819],
						[122.008808, 36.96225],
						[121.965076, 36.938337],
						[121.927504, 36.932597],
						[121.767975, 36.874691],
						[121.762432, 36.84644],
						[121.726092, 36.826323],
						[121.6762, 36.819137],
						[121.631853, 36.80093],
						[121.651563, 36.723739],
						[121.556092, 36.764502],
						[121.575186, 36.740047],
						[121.532071, 36.73621],
						[121.485259, 36.786073],
						[121.548701, 36.807638],
						[121.565331, 36.830635],
						[121.506817, 36.803805],
						[121.496962, 36.795179],
						[121.454462, 36.752515],
						[121.3941, 36.738129],
						[121.400876, 36.701191],
						[121.35776, 36.713186],
						[121.31218, 36.702151],
						[121.29863, 36.702151],
						[121.251818, 36.671436],
						[121.161275, 36.651273],
						[121.078123, 36.607568],
						[121.028848, 36.572971],
						[120.955551, 36.575855],
						[120.926602, 36.611892],
						[120.882255, 36.627262],
						[120.847146, 36.618617],
						[120.884718, 36.601323],
						[120.909972, 36.568645],
						[120.962327, 36.562877],
						[120.983269, 36.546051],
						[120.95432, 36.507578],
						[120.965407, 36.466199],
						[120.938305, 36.447908],
						[120.90874, 36.450315],
						[120.919827, 36.419018],
						[120.871784, 36.36699],
						[120.848994, 36.403124],
						[120.858849, 36.424797],
						[120.828668, 36.46668],
						[120.759683, 36.46283],
						[120.694393, 36.390118],
						[120.744284, 36.327946],
						[120.66298, 36.331803],
						[120.653741, 36.282129],
						[120.686386, 36.279234],
						[120.696857, 36.15563],
						[120.712255, 36.126632],
						[120.672835, 36.130016],
						[120.64327, 36.114547],
						[120.615553, 36.120348],
						[120.593995, 36.100525],
						[120.546568, 36.107778],
						[120.546568, 36.091821],
						[120.468959, 36.087952],
						[120.429539, 36.056994],
						[120.370409, 36.053607],
						[120.289721, 36.059413],
						[120.35809, 36.174956],
						[120.362402, 36.196209],
						[120.319902, 36.232423],
						[120.297112, 36.225664],
						[120.310047, 36.185101],
						[120.263236, 36.182202],
						[120.260772, 36.198624],
						[120.224432, 36.19138],
						[120.22012, 36.209248],
						[120.181316, 36.203936],
						[120.140664, 36.173507],
						[120.142512, 36.143549],
						[120.108635, 36.127599],
						[120.116642, 36.102943],
						[120.152367, 36.095206],
						[120.181316, 36.066669],
						[120.239214, 36.062316],
						[120.234902, 36.030863],
						[120.198562, 35.995525],
						[120.257076, 36.025055],
						[120.249069, 35.992136],
						[120.285409, 36.01247],
						[120.289721, 36.017311],
						[120.316206, 36.002304],
						[120.30512, 35.971796],
						[120.265699, 35.966468],
						[120.209033, 35.917531],
						[120.202258, 35.89184],
						[120.169613, 35.888446],
						[120.207801, 35.947575],
						[120.152983, 35.907353],
						[120.125265, 35.906868],
						[120.112331, 35.885052],
						[120.064287, 35.873414],
						[120.032258, 35.812288],
						[120.049505, 35.786562],
						[120.01378, 35.714193],
						[119.958346, 35.760342],
						[119.926317, 35.759856],
						[119.920157, 35.739943],
						[119.950339, 35.729741],
						[119.91215, 35.660725],
						[119.925085, 35.637382],
						[119.868419, 35.60868],
						[119.83023, 35.620357],
						[119.824071, 35.646136],
						[119.792658, 35.615492],
						[119.800665, 35.581915],
						[119.752622, 35.588729],
						[119.75139, 35.617924],
						[119.718129, 35.615492],
						[119.662079, 35.589215],
						[119.663311, 35.562931],
						[119.618963, 35.459655],
						[119.579543, 35.406504],
						[119.590014, 35.37284],
						[119.543819, 35.347949],
						[119.538275, 35.296678],
						[119.493312, 35.318655],
						[119.450812, 35.285443],
						[119.411392, 35.231689],
						[119.397841, 35.137777],
						[119.428022, 35.121136],
						[119.373819, 35.078538],
						[119.354109, 35.080007],
						[119.306066, 35.076578],
						[119.292515, 35.068742],
						[119.307298, 35.032977],
						[119.291899, 35.028567],
						[119.285124, 35.068252],
						[119.238313, 35.048657],
						[119.211211, 34.981507],
						[119.214907, 34.925589],
						[119.202588, 34.890253],
						[119.217371, 34.827886],
						[119.238313, 34.799388],
						[119.272189, 34.797914],
						[119.312841, 34.774813],
						[119.378747, 34.764489],
						[119.440957, 34.769406],
						[119.439725, 34.785136],
						[119.497007, 34.754164],
						[119.494543, 34.754656],
						[119.381827, 34.752198],
						[119.456971, 34.748264],
						[119.525956, 34.73351],
						[119.465594, 34.672994],
						[119.569072, 34.615389],
						[119.610956, 34.592729],
						[119.641137, 34.569078],
						[119.781571, 34.515839],
						[119.811752, 34.485754],
						[119.962657, 34.459112],
						[120.103707, 34.391481],
						[120.311895, 34.306991],
						[120.314359, 34.255563],
						[120.347619, 34.179352],
						[120.367329, 34.091674],
						[120.48559, 33.859411],
						[120.500372, 33.818152],
						[120.534249, 33.782346],
						[120.583524, 33.668362],
						[120.651277, 33.57567],
						[120.717183, 33.436945],
						[120.741205, 33.337505],
						[120.769538, 33.307],
						[120.813885, 33.303499],
						[120.833595, 33.274984],
						[120.819429, 33.237951],
						[120.843451, 33.209915],
						[120.874247, 33.093672],
						[120.871784, 33.047032],
						[120.917979, 33.02596],
						[120.932762, 33.005887],
						[120.957399, 32.893395],
						[120.981421, 32.85972],
						[120.972182, 32.761134],
						[120.953088, 32.714318],
						[120.916131, 32.701225],
						[120.963559, 32.68259],
						[120.979573, 32.636236],
						[120.961711, 32.612042],
						[121.020225, 32.605489],
						[121.153268, 32.52933],
						[121.269681, 32.483402],
						[121.352216, 32.474315],
						[121.390405, 32.460682],
						[121.425513, 32.430885],
						[121.450151, 32.282256],
						[121.493882, 32.263533],
						[121.499426, 32.211394],
						[121.458774, 32.177462],
						[121.542542, 32.152132],
						[121.525295, 32.136423],
						[121.759352, 32.059362],
						[121.772287, 32.032984],
						[121.856055, 31.955328],
						[121.889315, 31.866425],
						[121.970004, 31.718911],
						[121.974931, 31.61704],
						[121.995873, 31.493117],
						[121.981706, 31.464024],
						[121.890547, 31.428795],
						[121.819098, 31.437987],
						[121.682976, 31.491075],
						[121.625693, 31.501792],
						[121.547469, 31.531382],
						[121.434136, 31.590535],
						[121.395332, 31.585437],
						[121.371926, 31.553314],
						[121.343593, 31.511996],
						[121.404571, 31.479337],
						[121.520984, 31.394575],
						[121.599208, 31.37465],
						[121.722396, 31.3036],
						[121.809859, 31.196669],
						[121.946598, 31.066039],
						[121.977395, 31.016301],
						[121.990945, 30.96859],
						[121.994025, 30.862823],
						[121.954605, 30.825828],
						[121.970004, 30.789333],
						[121.987866, 30.753338],
						[121.992793, 30.695204],
						[122.011271, 30.66947],
						[122.075329, 30.647848],
						[122.133227, 30.595317],
						[122.087032, 30.602014],
						[121.997105, 30.658659],
						[121.968156, 30.688514],
						[121.943518, 30.776993],
						[121.904714, 30.814007],
						[121.681128, 30.818633],
						[121.601056, 30.805269],
						[121.517288, 30.775451],
						[121.426129, 30.730192],
						[121.362071, 30.679764],
						[121.274608, 30.677191],
						[121.239499, 30.648878],
						[121.188992, 30.632916],
						[121.148956, 30.599953],
						[121.058413, 30.563888],
						[121.092906, 30.515952],
						[121.183449, 30.434458],
						[121.225333, 30.404526],
						[121.328195, 30.397299],
						[121.371926, 30.37097],
						[121.395332, 30.338435],
						[121.497578, 30.258861],
						[121.561636, 30.184395],
						[121.635548, 30.070002],
						[121.652795, 30.071037],
						[121.699606, 30.007832],
						[121.721164, 29.992802],
						[121.78399, 29.99332],
						[121.835113, 29.958068],
						[121.919497, 29.920729],
						[121.971235, 29.955476],
						[122.00388, 29.92021],
						[122.00696, 29.891678],
						[122.140003, 29.901535],
						[122.143082, 29.877668],
						[122.10243, 29.859504],
						[122.043916, 29.822647],
						[122.003264, 29.762401],
						[121.937359, 29.748373],
						[121.833265, 29.653242],
						[121.872685, 29.632437],
						[121.909641, 29.650122],
						[121.966308, 29.636078],
						[122.000185, 29.582486],
						[121.995257, 29.545007],
						[121.968772, 29.515846],
						[121.973083, 29.477821],
						[121.993409, 29.45229],
						[121.975547, 29.411113],
						[121.937975, 29.384],
						[121.936127, 29.348012],
						[121.958301, 29.334448],
						[121.94475, 29.28435],
						[122.000185, 29.278608],
						[122.002032, 29.260336],
						[121.966924, 29.249894],
						[121.971851, 29.193485],
						[121.948446, 29.193485],
						[121.986634, 29.154817],
						[121.988482, 29.110906],
						[121.970004, 29.092604],
						[121.966308, 29.052852],
						[121.884388, 29.105677],
						[121.85975, 29.086328],
						[121.811091, 29.10986],
						[121.780294, 29.10986],
						[121.767975, 29.166837],
						[121.750113, 29.136523],
						[121.715621, 29.125022],
						[121.608447, 29.168927],
						[121.616454, 29.143318],
						[121.660186, 29.118226],
						[121.658954, 29.058606],
						[121.712541, 29.028783],
						[121.711309, 28.985865],
						[121.743338, 28.954451],
						[121.772287, 28.898404],
						[121.774751, 28.863818],
						[121.687287, 28.863294],
						[121.704534, 28.804577],
						[121.689135, 28.719062],
						[121.646019, 28.682842],
						[121.540694, 28.655537],
						[121.557324, 28.645033],
						[121.596128, 28.575156],
						[121.634317, 28.562542],
						[121.646019, 28.511544],
						[121.671273, 28.472621],
						[121.692831, 28.407368],
						[121.658954, 28.392628],
						[121.634317, 28.347868],
						[121.660186, 28.355768],
						[121.669425, 28.33312],
						[121.627541, 28.251966],
						[121.580114, 28.240368],
						[121.571491, 28.279376],
						[121.538846, 28.299401],
						[121.488955, 28.301509],
						[121.45631, 28.250385],
						[121.402107, 28.197127],
						[121.373774, 28.133287],
						[121.328195, 28.134343],
						[121.299862, 28.067297],
						[121.261057, 28.034551],
						[121.176058, 28.022401],
						[121.140949, 28.031382],
						[121.121239, 28.12537],
						[121.108304, 28.139092],
						[121.059029, 28.096338],
						[121.015298, 27.981714],
						[120.991892, 27.95],
						[121.05595, 27.900294],
						[121.099681, 27.895005],
						[121.162507, 27.90717],
						[121.162507, 27.879136],
						[121.193304, 27.872259],
						[121.192072, 27.822518],
						[121.152652, 27.810344],
						[121.153268, 27.809815],
						[121.149572, 27.801875],
						[121.149572, 27.801345],
						[121.13479, 27.787051],
						[121.134174, 27.787051],
						[121.152036, 27.815638],
						[121.107688, 27.81352],
						[121.070116, 27.834162],
						[121.027616, 27.832574],
						[120.97403, 27.887071],
						[120.942001, 27.896592],
						[120.910588, 27.864852],
						[120.840371, 27.758986],
						[120.797871, 27.779638],
						[120.760915, 27.717671],
						[120.709176, 27.682699],
						[120.685154, 27.622797],
						[120.634647, 27.577186],
						[120.637111, 27.561271],
						[120.703016, 27.478475],
						[120.673451, 27.420055],
						[120.665444, 27.357884],
						[120.580444, 27.321203],
						[120.554575, 27.25206],
						[120.574901, 27.234501],
						[120.545952, 27.156785],
						[120.492365, 27.136016],
						[120.461568, 27.142407],
						[120.403054, 27.10086],
						[120.391967, 27.081146],
						[120.282946, 27.089671],
						[120.29588, 27.035845],
						[120.275554, 27.027315],
						[120.279866, 26.987326],
						[120.25954, 26.982526],
						[120.232439, 26.907303],
						[120.1807, 26.920644],
						[120.117258, 26.916909],
						[120.103707, 26.873143],
						[120.037802, 26.86033],
						[120.042729, 26.828292],
						[120.082765, 26.822417],
						[120.103707, 26.794642],
						[120.136352, 26.797847],
						[120.106787, 26.752966],
						[120.151135, 26.750829],
						[120.162222, 26.717691],
						[120.110483, 26.692563],
						[120.1382, 26.638012],
						[120.093852, 26.613938],
						[120.063671, 26.627848],
						[120.007621, 26.595744],
						[119.967585, 26.597885],
						[119.93802, 26.576478],
						[119.947875, 26.56042],
						[119.867187, 26.509019],
						[119.828383, 26.524013],
						[119.851788, 26.595209],
						[119.901679, 26.624638],
						[119.949107, 26.624638],
						[119.972512, 26.654594],
						[119.969433, 26.686681],
						[119.99407, 26.720363],
						[120.061824, 26.768997],
						[120.052584, 26.786629],
						[119.942947, 26.784492],
						[119.938636, 26.747088],
						[119.899216, 26.693098],
						[119.908455, 26.661547],
						[119.873962, 26.642827],
						[119.864107, 26.671174],
						[119.833926, 26.690959],
						[119.711354, 26.686681],
						[119.664543, 26.726243],
						[119.637441, 26.703256],
						[119.619579, 26.649246],
						[119.577695, 26.622498],
						[119.605412, 26.595744],
						[119.670086, 26.618218],
						[119.740303, 26.610727],
						[119.788346, 26.583435],
						[119.83639, 26.454381],
						[119.835774, 26.434019],
						[119.893672, 26.355752],
						[119.946027, 26.374519],
						[119.95465, 26.352534],
						[119.909687, 26.310161],
						[119.862875, 26.307479],
						[119.845013, 26.323036],
						[119.806825, 26.307479],
						[119.802513, 26.268846],
						[119.7711, 26.285481],
						[119.676246, 26.262943],
						[119.664543, 26.202282],
						[119.604181, 26.168985],
						[119.618963, 26.11956],
						[119.654688, 26.090002],
						[119.668854, 26.026024],
						[119.700267, 26.032477],
						[119.723673, 26.011503],
						[119.69534, 25.904424],
						[119.638057, 25.889888],
						[119.628202, 25.87212],
						[119.626354, 25.723406],
						[119.602949, 25.714779],
						[119.602949, 25.68512],
						[119.543819, 25.684581],
						[119.472986, 25.662466],
						[119.478529, 25.631715],
						[119.541355, 25.6247],
						[119.534579, 25.585303],
						[119.586934, 25.59232],
						[119.616499, 25.556691],
						[119.611572, 25.519972],
						[119.634362, 25.475137],
						[119.675014, 25.475137],
						[119.680557, 25.497827],
						[119.715666, 25.51187],
						[119.716898, 25.551292],
						[119.683637, 25.592859],
						[119.700267, 25.616606],
						[119.784651, 25.667321],
						[119.790194, 25.614447],
						[119.843165, 25.597717],
						[119.831462, 25.579905],
						[119.883817, 25.546432],
						[119.861027, 25.531313],
						[119.81668, 25.532393],
						[119.811136, 25.507009],
						[119.83331, 25.48162],
						[119.864107, 25.48],
						[119.866571, 25.455145],
						[119.804977, 25.457847],
						[119.764325, 25.433529],
						[119.773564, 25.395691],
						[119.688564, 25.441095],
						[119.682405, 25.445959],
						[119.675014, 25.468113],
						[119.622659, 25.434069],
						[119.670086, 25.435691],
						[119.656535, 25.396772],
						[119.665159, 25.3719],
						[119.649144, 25.342697],
						[119.597405, 25.334584],
						[119.582623, 25.374063],
						[119.59063, 25.398394],
						[119.577695, 25.445959],
						[119.555521, 25.429205],
						[119.578927, 25.400556],
						[119.548746, 25.365952],
						[119.486536, 25.369737],
						[119.507478, 25.396231],
						[119.48592, 25.418935],
						[119.491464, 25.443257],
						[119.463131, 25.448661],
						[119.438493, 25.412449],
						[119.45266, 25.493505],
						[119.400921, 25.493505],
						[119.359037, 25.521592],
						[119.343638, 25.472436],
						[119.353493, 25.411908],
						[119.288204, 25.410827],
						[119.26295, 25.428124],
						[119.275269, 25.476758],
						[119.256175, 25.488643],
						[119.219834, 25.468654],
						[119.191501, 25.424341],
						[119.151465, 25.426503],
						[119.14469, 25.388121],
						[119.218603, 25.368115],
						[119.240776, 25.316733],
						[119.247552, 25.333502],
						[119.299291, 25.328634],
						[119.333167, 25.287516],
						[119.380595, 25.250173],
						[119.331935, 25.230685],
						[119.294979, 25.237182],
						[119.314689, 25.190076],
						[119.26911, 25.159746],
						[119.231537, 25.188993],
						[119.190269, 25.175995],
						[119.131755, 25.223106],
						[119.108349, 25.193867],
						[119.137299, 25.15487],
						[119.165632, 25.145661],
						[119.146538, 25.056782],
						[119.119436, 25.012861],
						[119.107118, 25.075214],
						[119.134219, 25.106107],
						[119.075705, 25.099604],
						[119.06585, 25.102855],
						[119.028893, 25.139702],
						[119.032589, 25.17437],
						[119.054147, 25.168412],
						[119.074473, 25.211195],
						[119.055379, 25.219316],
						[118.990089, 25.20199],
						[118.975307, 25.237723],
						[118.996864, 25.266411],
						[118.956212, 25.272905],
						[118.91556, 25.256668],
						[118.940198, 25.21715],
						[118.942046, 25.211195],
						[118.985162, 25.19495],
						[118.985162, 25.168954],
						[118.951901, 25.15162],
						[118.974691, 25.115319],
						[118.892155, 25.092558],
						[118.945126, 25.028588],
						[118.974691, 25.024792],
						[119.016575, 25.058409],
						[119.023966, 25.04377],
						[118.989473, 24.973807],
						[119.004872, 24.970009],
						[119.007335, 24.963499],
						[119.032589, 24.961871],
						[119.032589, 24.961328],
						[119.014111, 24.941252],
						[118.945741, 24.954275],
						[118.91864, 24.932569],
						[118.932807, 24.906518],
						[118.987009, 24.898375],
						[118.988857, 24.878831],
						[118.933423, 24.870687],
						[118.864437, 24.887518],
						[118.834256, 24.854397],
						[118.807771, 24.870687],
						[118.748641, 24.84245],
						[118.69875, 24.848967],
						[118.702445, 24.865258],
						[118.647627, 24.843536],
						[118.650707, 24.808774],
						[118.786213, 24.77672],
						[118.778822, 24.743569],
						[118.703677, 24.665278],
						[118.670417, 24.679962],
						[118.652554, 24.653857],
						[118.661178, 24.622306],
						[118.687047, 24.63373],
						[118.680272, 24.58204],
						[118.614366, 24.521617],
						[118.558316, 24.51236],
						[118.557084, 24.572788],
						[118.512736, 24.60816],
						[118.444367, 24.614689],
						[118.363679, 24.567889],
						[118.375382, 24.536317],
						[118.242955, 24.51236],
						[118.169042, 24.559725],
						[118.150564, 24.583673],
						[118.121615, 24.570067],
						[118.084042, 24.528695],
						[118.048934, 24.418122],
						[118.088354, 24.408858],
						[118.081579, 24.35653],
						[118.112376, 24.357075],
						[118.158571, 24.269814],
						[118.115455, 24.229435],
						[118.074803, 24.225615],
						[118.019369, 24.197232],
						[118.000275, 24.152462],
						[117.936217, 24.100029],
						[117.927594, 24.039922],
						[117.910347, 24.012045],
						[117.864768, 24.004938],
						[117.807486, 23.947521],
						[117.792703, 23.906494],
						[117.762522, 23.886796],
						[117.691073, 23.888985],
						[117.671979, 23.878041],
						[117.651653, 23.815093],
						[117.660276, 23.789357],
						[117.601762, 23.70171],
						[117.54448, 23.715956],
						[117.501364, 23.70445],
						[117.493357, 23.642514],
						[117.454552, 23.628259],
						[117.463791, 23.584937],
						[117.387415, 23.555317],
						[117.302415, 23.550379],
						[117.291328, 23.571225],
						[117.192778, 23.5619],
						[117.085605, 23.536663],
						[117.044953, 23.539955],
						[117.01046, 23.502641],
						[116.963649, 23.507031],
						[116.92854, 23.530079],
						[116.888504, 23.501543],
						[116.895895, 23.476295],
						[116.874953, 23.447748],
						[116.874338, 23.447199],
						[116.871258, 23.416449],
						[116.871874, 23.4159],
						[116.782563, 23.313714],
						[116.798577, 23.244996],
						[116.821367, 23.240597],
						[116.806584, 23.200998],
						[116.74499, 23.215299],
						[116.701259, 23.198248],
						[116.665534, 23.158086],
						[116.566368, 23.134424],
						[116.550969, 23.109656],
						[116.566368, 23.088738],
						[116.557129, 23.056253],
						[116.576839, 23.014397],
						[116.542346, 22.995667],
						[116.50539, 22.930645],
						[116.449955, 22.936707],
						[116.382818, 22.91907],
						[116.317528, 22.95269],
						[116.226985, 22.91466],
						[116.191261, 22.874965],
						[116.104413, 22.816505],
						[116.05637, 22.844635],
						[115.99724, 22.826985],
						[115.965211, 22.800506],
						[115.931334, 22.802713],
						[115.883291, 22.78561],
						[115.829089, 22.734838],
						[115.796444, 22.739254],
						[115.788437, 22.809885],
						[115.760103, 22.834707],
						[115.696046, 22.84298],
						[115.654162, 22.865591],
						[115.583945, 22.82864],
						[115.570394, 22.786713],
						[115.541445, 22.755259],
						[115.609198, 22.753052],
						[115.565467, 22.684048],
						[115.575322, 22.650914],
						[115.471844, 22.697852],
						[115.430576, 22.684048],
						[115.381301, 22.684048],
						[115.349272, 22.712206],
						[115.338185, 22.776781],
						[115.319091, 22.783402],
						[115.230396, 22.776781],
						[115.236555, 22.82533],
						[115.190359, 22.818711],
						[115.190975, 22.77347],
						[115.154635, 22.80161],
						[115.061628, 22.783402],
						[115.053621, 22.747533],
						[115.02344, 22.726007],
						[115.039454, 22.713862],
						[114.945216, 22.645391],
						[114.927969, 22.621639],
						[114.922426, 22.549253],
						[114.88547, 22.538751],
						[114.866375, 22.591805],
						[114.746267, 22.581859],
						[114.743803, 22.632687],
						[114.728405, 22.651466],
						[114.73518, 22.724351],
						[114.749963, 22.764089],
						[114.709927, 22.787817],
						[114.689601, 22.7674],
						[114.601521, 22.730975],
						[114.591666, 22.690122],
						[114.567029, 22.685705],
						[114.51529, 22.655332],
						[114.579964, 22.661407],
						[114.603369, 22.638763],
						[114.559022, 22.583517],
						[114.568261, 22.560859],
						[114.614456, 22.545384],
						[114.628623, 22.513875],
						[114.611377, 22.481806],
						[114.549167, 22.465769],
						[114.506667, 22.438667],
						[114.476486, 22.459132],
						[114.472174, 22.522168],
						[114.427211, 22.589042],
						[114.381631, 22.60175],
						[114.321885, 22.587385],
						[114.294784, 22.563623],
						[114.232574, 22.539857],
						[114.222719, 22.553122],
						[114.166052, 22.559201],
						[114.156813, 22.543726],
						[114.095219, 22.534329],
						[114.082285, 22.512216],
						[114.031778, 22.503923],
						[113.976343, 22.510558],
						[113.954785, 22.491206],
						[113.952937, 22.486783],
						[113.893807, 22.442539],
						[113.869786, 22.459685],
						[113.856851, 22.539857],
						[113.803264, 22.593463],
						[113.773083, 22.643182],
						[113.751525, 22.715518],
						[113.733663, 22.736494],
						[113.678228, 22.726007],
						[113.717033, 22.645391],
						[113.740438, 22.534329],
						[113.691779, 22.514981],
						[113.668373, 22.4807],
						[113.631417, 22.475723],
						[113.573519, 22.41156],
						[113.608627, 22.408793],
						[113.624642, 22.443092],
						[113.66591, 22.438667],
						[113.669605, 22.416539],
						[113.627721, 22.349027],
						[113.604932, 22.339617],
						[113.617866, 22.315259],
						[113.595693, 22.304186],
						[113.594461, 22.228864],
						[113.558736, 22.212244],
						[113.53841, 22.209473],
						[113.534715, 22.174009],
						[113.554425, 22.142416],
						[113.554425, 22.107489],
						[113.567359, 22.075327],
						[113.527939, 22.073663],
						[113.45957, 22.043711],
						[113.442324, 22.009315],
						[113.330223, 21.96159],
						[113.319752, 21.909407],
						[113.266781, 21.871646],
						[113.235368, 21.887751],
						[113.1516, 21.979905],
						[113.142977, 22.012089],
						[113.091854, 22.065344],
						[113.086927, 22.12634],
						[113.045659, 22.088636],
						[113.032108, 22.04593],
						[113.053666, 22.012089],
						[113.047507, 21.956595],
						[112.989608, 21.869424],
						[112.929862, 21.838875],
						[112.893522, 21.84443],
						[112.841167, 21.920512],
						[112.792508, 21.921067],
						[112.68595, 21.810541],
						[112.647146, 21.758302],
						[112.535661, 21.753856],
						[112.497473, 21.785535],
						[112.445734, 21.803317],
						[112.427256, 21.789981],
						[112.415553, 21.734956],
						[112.353343, 21.707157],
						[112.238778, 21.702153],
						[112.236315, 21.727173],
						[112.196894, 21.736624],
						[112.192583, 21.789425],
						[112.136532, 21.793871],
						[112.036134, 21.761637],
						[111.956062, 21.710494],
						[111.954214, 21.667674],
						[111.997946, 21.657107],
						[112.026895, 21.633744],
						[111.972692, 21.603144],
						[111.941896, 21.607039],
						[111.887693, 21.578659],
						[111.810084, 21.555283],
						[111.832258, 21.578659],
						[111.794686, 21.61149],
						[111.736788, 21.609821],
						[111.693672, 21.590345],
						[111.677658, 21.529677],
						[111.650556, 21.512418],
						[111.609904, 21.530234],
						[111.560629, 21.50518],
						[111.521825, 21.517429],
						[111.494724, 21.501282],
						[111.444217, 21.514088],
						[111.382623, 21.495714],
						[111.353058, 21.464528],
						[111.28592, 21.41885],
						[111.258819, 21.412165],
						[111.253275, 21.452831],
						[111.276065, 21.443362],
						[111.28284, 21.485691],
						[111.171355, 21.458401],
						[111.103602, 21.455616],
						[111.034617, 21.438906],
						[110.929291, 21.375945],
						[110.888639, 21.367585],
						[110.796248, 21.37483],
						[110.768531, 21.364799],
						[110.713097, 21.3124],
						[110.65951, 21.239902],
						[110.626249, 21.215915],
						[110.534474, 21.204198],
						[110.501213, 21.217588],
						[110.451322, 21.186343],
						[110.422373, 21.190807],
						[110.39096, 21.124949],
						[110.296722, 21.093684],
						[110.24991, 21.045098],
						[110.241903, 21.016051],
						[110.208642, 21.050684],
						[110.204947, 21.003202],
						[110.180925, 20.98197],
						[110.184005, 20.891979],
						[110.209874, 20.860106],
						[110.269004, 20.839972],
						[110.327519, 20.847802],
						[110.393424, 20.816479],
						[110.407591, 20.731987],
						[110.392192, 20.682724],
						[110.411286, 20.670966],
						[110.466105, 20.680485],
						[110.487047, 20.640167],
						[110.499982, 20.572386],
						[110.550489, 20.47262],
						[110.54125, 20.42047],
						[110.491358, 20.373912],
						[110.452554, 20.311064],
						[110.425453, 20.291419],
						[110.384185, 20.293103],
						[110.349076, 20.258859],
						[110.296722, 20.249314],
						[110.220345, 20.25156],
						[110.168606, 20.219553],
						[110.118099, 20.219553],
						[110.082375, 20.258859],
						[109.993679, 20.254368],
						[109.929006, 20.211691],
						[109.909296, 20.236961],
						[109.916071, 20.316677],
						[109.861252, 20.376717],
						[109.864948, 20.40196],
						[109.895745, 20.42776],
						[109.888354, 20.475423],
						[109.839695, 20.489439],
						[109.811977, 20.541566],
						[109.813825, 20.574627],
						[109.793499, 20.615522],
						[109.74484, 20.621124],
						[109.730057, 20.719673],
						[109.711579, 20.774519],
						[109.664768, 20.862343],
						[109.655529, 20.929435],
						[109.674007, 21.067997],
						[109.674623, 21.136671],
						[109.763934, 21.226514],
						[109.757775, 21.346963],
						[109.770709, 21.359783],
						[109.868644, 21.365913],
						[109.904368, 21.429992],
						[109.894513, 21.442248],
						[109.819369, 21.445033],
						[109.785492, 21.45673],
						[109.704188, 21.462857],
						[109.654913, 21.493487],
						[109.612413, 21.556953],
						[109.581, 21.548047],
						[109.576689, 21.493487],
						[109.540964, 21.466199],
						[109.484914, 21.453388],
						[109.41716, 21.438906],
						[109.245929, 21.425536],
						[109.186183, 21.390991],
						[109.138756, 21.388762],
						[109.095024, 21.419407],
						[109.046365, 21.424421],
						[109.039589, 21.457844],
						[109.074698, 21.489589],
						[109.142451, 21.511861],
						[109.138756, 21.567528],
						[109.110422, 21.568085],
						[109.09872, 21.571424],
						[109.093792, 21.579215],
						[108.937959, 21.589789],
						[108.881293, 21.627068],
						[108.83325, 21.610933],
						[108.801837, 21.626512],
						[108.745786, 21.602587],
						[108.710062, 21.646538],
						[108.705134, 21.622061],
						[108.678033, 21.659331],
						[108.658939, 21.643757],
						[108.626294, 21.67991],
						[108.591802, 21.677129],
						[108.492635, 21.554727],
						[108.397781, 21.533017],
						[108.330027, 21.540254],
						[108.230245, 21.491259],
						[108.210535, 21.505737],
						[108.249955, 21.561406],
						[108.241332, 21.599805],
						[108.205608, 21.597579],
						[108.156332, 21.55083],
						[108.193905, 21.519656],
						[108.108289, 21.508521],
						[108.041768, 21.544151],
						[107.958, 21.534131],
						[107.929051, 21.585893],
						[107.893942, 21.596466],
						[107.892095, 21.622617],
						[107.863761, 21.650988],
						[107.837892, 21.640419],
						[107.807711, 21.655438],
						[107.712856, 21.616497],
						[107.603219, 21.597579],
						[107.584741, 21.614828],
						[107.547168, 21.58645],
						[107.486806, 21.59591],
						[107.500973, 21.613715],
						[107.477567, 21.659888],
						[107.431372, 21.642088],
						[107.388256, 21.594241],
						[107.363619, 21.602031],
						[107.356843, 21.667674],
						[107.310648, 21.733844],
						[107.271844, 21.727173],
						[107.242279, 21.703265],
						[107.199163, 21.718833],
						[107.194851, 21.736624],
						[107.148656, 21.758858],
						[107.093837, 21.803317],
						[107.018077, 21.81943],
						[107.018693, 21.859427],
						[107.058729, 21.887196],
						[107.05996, 21.914959],
						[106.999598, 21.947714],
						[106.974345, 21.923288],
						[106.935541, 21.933836],
						[106.926302, 21.967695],
						[106.859164, 21.986009],
						[106.802498, 21.98157],
						[106.790179, 22.004876],
						[106.73844, 22.008205],
						[106.698404, 21.959925],
						[106.683006, 21.999882],
						[106.706411, 22.021521],
						[106.71565, 22.089745],
						[106.691629, 22.13521],
						[106.706411, 22.160707],
						[106.673151, 22.182322],
						[106.7021, 22.207257],
						[106.688549, 22.260438],
						[106.670071, 22.283144],
						[106.663296, 22.33076],
						[106.562897, 22.345706],
						[106.588767, 22.374486],
						[106.560434, 22.455813],
						[106.588151, 22.472958],
						[106.585071, 22.517192],
						[106.61402, 22.602303],
						[106.652825, 22.57357],
						[106.711955, 22.575228],
						[106.756302, 22.68957],
						[106.780324, 22.708894],
						[106.768621, 22.739254],
						[106.820976, 22.768504],
						[106.838838, 22.803265],
						[106.813585, 22.817608],
						[106.808657, 22.817608],
						[106.804346, 22.816505],
						[106.801882, 22.815401],
						[106.776012, 22.813746],
						[106.709491, 22.866142],
						[106.716882, 22.881582],
						[106.674998, 22.891506],
						[106.657136, 22.863385],
						[106.631267, 22.88103],
						[106.606013, 22.925684],
						[106.562282, 22.923479],
						[106.525941, 22.946628],
						[106.504383, 22.91025],
						[106.41384, 22.877171],
						[106.37134, 22.878273],
						[106.366413, 22.857871],
						[106.286957, 22.867245],
						[106.258007, 22.889852],
						[106.270326, 22.907494],
						[106.206885, 22.978588],
						[106.153914, 22.988505],
						[106.106486, 22.980792],
						[106.08616, 22.996218],
						[106.019639, 22.990709],
						[105.994385, 22.93781],
						[105.959277, 22.948832],
						[105.893987, 22.936707],
						[105.879205, 22.916865],
						[105.839169, 22.987403],
						[105.805908, 22.994565],
						[105.780039, 23.022659],
						[105.74185, 23.030921],
						[105.724604, 23.06231],
						[105.648844, 23.078828],
						[105.625438, 23.064513],
						[105.574931, 23.066165],
						[105.558916, 23.177893],
						[105.542902, 23.184495],
						[105.50225, 23.202648],
						[105.445584, 23.292827],
						[105.416018, 23.283482],
						[105.372903, 23.317561],
						[105.353809, 23.362069],
						[105.325475, 23.390086],
						[105.260186, 23.31811],
						[105.238012, 23.26424],
						[105.181962, 23.279084],
						[105.122215, 23.247745],
						[105.093266, 23.260942],
						[104.958991, 23.188896],
						[104.949136, 23.152033],
						[104.912796, 23.175693],
						[104.882615, 23.163589],
						[104.874608, 23.123417],
						[104.804391, 23.110207],
						[104.821021, 23.032022],
						[104.860441, 22.970874],
						[104.846275, 22.926235],
						[104.772362, 22.893711],
						[104.760659, 22.862282],
						[104.732942, 22.852356],
						[104.737869, 22.825882],
						[104.674428, 22.817056],
						[104.596203, 22.846289],
						[104.527834, 22.814298],
						[104.498885, 22.774574],
						[104.422508, 22.734838],
						[104.375697, 22.690122],
						[104.323342, 22.728767],
						[104.272835, 22.73815],
						[104.256821, 22.77347],
						[104.274067, 22.828088],
						[104.261748, 22.841877],
						[104.224176, 22.826434],
						[104.117618, 22.808781],
						[104.089901, 22.768504],
						[104.045553, 22.728215],
						[104.04309, 22.67687],
						[104.022148, 22.593463],
						[104.009213, 22.575228],
						[104.009213, 22.517745],
						[103.964865, 22.502265],
						[103.894032, 22.564728],
						[103.875554, 22.565833],
						[103.863851, 22.584069],
						[103.825047, 22.615562],
						[103.766533, 22.688465],
						[103.669215, 22.766297],
						[103.642113, 22.794989],
						[103.567585, 22.701164],
						[103.580519, 22.66693],
						[103.529396, 22.59291],
						[103.50907, 22.601198],
						[103.457947, 22.658646],
						[103.436389, 22.6973],
						[103.441317, 22.753052],
						[103.375411, 22.794989],
						[103.323057, 22.807678],
						[103.321209, 22.777885],
						[103.288564, 22.732078],
						[103.283021, 22.678526],
						[103.220195, 22.643734],
						[103.195557, 22.648153],
						[103.161065, 22.590147],
						[103.183238, 22.558649],
						[103.119181, 22.518298],
						[103.085304, 22.509452],
						[103.071753, 22.445304],
						[103.030485, 22.441432],
						[102.986754, 22.477935],
						[102.930703, 22.482359],
						[102.892515, 22.533223],
						[102.880196, 22.586832],
						[102.82353, 22.623296],
						[102.80074, 22.620534],
						[102.688639, 22.70006],
						[102.657226, 22.687913],
						[102.607335, 22.730975],
						[102.569763, 22.701164],
						[102.551285, 22.743669],
						[102.498314, 22.777885],
						[102.45951, 22.762986],
						[102.43672, 22.699508],
						[102.384365, 22.679631],
						[102.404691, 22.629925],
						[102.356648, 22.563623],
						[102.322771, 22.554227],
						[102.25625, 22.457473],
						[102.270416, 22.419858],
						[102.179257, 22.430369],
						[102.145381, 22.397727],
						[102.131214, 22.430922],
						[102.046214, 22.458026],
						[101.978461, 22.427603],
						[101.907628, 22.437007],
						[101.901469, 22.384447],
						[101.862665, 22.389427],
						[101.823244, 22.42705],
						[101.824476, 22.45692],
						[101.774585, 22.506135],
						[101.715455, 22.477935],
						[101.672339, 22.47517],
						[101.648318, 22.400494],
						[101.671723, 22.372826],
						[101.625528, 22.28259],
						[101.56455, 22.269299],
						[101.547304, 22.238282],
						[101.596579, 22.161262],
						[101.602738, 22.131883],
						[101.573789, 22.115251],
						[101.626144, 22.005986],
						[101.606434, 21.967695],
						[101.666796, 21.934391],
						[101.701288, 21.938832],
						[101.700057, 21.897191],
						[101.735165, 21.875534],
						[101.740093, 21.845541],
						[101.771506, 21.833319],
						[101.747484, 21.729953],
						[101.76781, 21.716054],
						[101.780129, 21.640975],
						[101.807846, 21.644313],
						[101.828788, 21.617054],
						[101.804766, 21.577546],
						[101.754875, 21.58478],
						[101.755491, 21.538027],
						[101.772737, 21.512975],
						[101.741324, 21.482906],
						[101.749948, 21.409379],
						[101.730238, 21.336929],
						[101.745636, 21.297345],
						[101.791832, 21.285636],
						[101.833715, 21.252731],
						[101.834331, 21.204756],
						[101.794911, 21.208104],
						[101.76473, 21.147835],
						[101.703136, 21.14616],
						[101.672339, 21.194713],
						[101.605818, 21.172392],
						[101.588572, 21.191365],
						[101.601506, 21.233208],
						[101.532521, 21.252174],
						[101.439514, 21.227072],
						[101.387775, 21.225956],
						[101.290457, 21.17853],
						[101.222088, 21.234324],
						[101.246725, 21.275598],
						[101.244877, 21.302364],
						[101.183899, 21.334699],
						[101.142631, 21.409379],
						[101.194986, 21.424979],
						[101.193138, 21.473996],
						[101.225167, 21.499055],
						[101.210385, 21.509077],
						[101.209153, 21.55751],
						[101.146943, 21.560293],
						[101.169117, 21.590345],
						[101.153102, 21.669343],
						[101.116762, 21.691032],
						[101.111835, 21.746074],
						[101.123537, 21.771642],
						[101.089661, 21.773865],
						[101.015132, 21.707157],
						[100.940603, 21.697149],
						[100.870386, 21.67268],
						[100.847597, 21.634856],
						[100.804481, 21.609821],
						[100.789082, 21.570867],
						[100.753358, 21.555283],
						[100.730568, 21.518542],
						[100.691764, 21.510748],
						[100.579047, 21.451717],
						[100.526692, 21.471211],
						[100.48296, 21.458958],
						[100.437381, 21.533017],
						[100.350534, 21.52912],
						[100.298795, 21.477894],
						[100.235353, 21.466756],
						[100.206404, 21.509634],
						[100.180534, 21.514088],
						[100.168831, 21.482906],
						[100.131259, 21.504066],
						[100.123252, 21.565302],
						[100.107853, 21.585337],
						[100.169447, 21.663225],
						[100.131875, 21.699929],
						[100.094303, 21.702709],
						[100.049339, 21.669899],
						[99.991441, 21.703821],
						[99.944014, 21.821097],
						[99.960028, 21.907186],
						[99.982202, 21.919401],
						[100.000064, 21.973245],
						[99.965571, 22.014309],
						[99.972347, 22.053141],
						[99.871333, 22.067007],
						[99.870101, 22.029288],
						[99.762927, 22.068117],
						[99.696406, 22.067562],
						[99.648979, 22.100835],
						[99.581841, 22.103053],
						[99.578762, 22.098617],
						[99.562747, 22.113034],
						[99.516552, 22.099726],
						[99.486987, 22.128557],
						[99.400139, 22.100281],
						[99.35456, 22.095845],
						[99.294814, 22.109152],
						[99.219669, 22.110816],
						[99.156227, 22.159599],
						[99.188256, 22.162924],
						[99.175321, 22.185647],
						[99.207966, 22.232188],
						[99.235683, 22.250468],
						[99.233836, 22.296434],
						[99.278183, 22.34626],
						[99.251698, 22.393301],
						[99.297277, 22.41156],
						[99.382277, 22.493418],
						[99.359487, 22.535435],
						[99.385973, 22.57136],
						[99.339777, 22.708894],
						[99.31514, 22.737598],
						[99.326842, 22.751396],
						[99.385357, 22.761882],
						[99.401371, 22.826434],
						[99.462965, 22.844635],
						[99.43648, 22.913557],
						[99.446951, 22.934503],
						[99.531334, 22.897019],
						[99.563363, 22.925684],
						[99.533798, 22.961507],
						[99.517168, 23.006685],
						[99.528255, 23.065614],
						[99.477747, 23.083233],
						[99.440791, 23.079379],
						[99.380429, 23.099748],
						[99.3484, 23.12892],
						[99.281879, 23.101399],
						[99.255393, 23.077727],
						[99.187024, 23.100299],
						[99.106336, 23.086536],
						[99.048438, 23.11461],
						[99.057677, 23.164689],
						[99.002242, 23.160287],
						[98.906772, 23.185595],
						[98.889525, 23.209249],
						[98.928946, 23.26589],
						[98.936953, 23.309866],
						[98.906772, 23.331849],
						[98.872895, 23.329651],
						[98.920938, 23.360971],
						[98.912315, 23.426333],
						[98.874743, 23.483431],
						[98.826084, 23.470257],
						[98.80391, 23.540504],
						[98.844562, 23.578904],
						[98.882134, 23.595358],
						[98.882134, 23.620035],
						[98.847026, 23.632097],
						[98.835939, 23.683625],
						[98.811917, 23.703354],
						[98.824236, 23.727462],
						[98.784816, 23.781691],
						[98.696121, 23.784429],
						[98.669019, 23.800857],
						[98.701664, 23.834254],
						[98.68565, 23.90157],
						[98.701048, 23.946427],
						[98.673331, 23.960647],
						[98.701048, 23.981427],
						[98.727533, 23.970491],
						[98.773729, 24.022431],
						[98.807606, 24.025164],
						[98.895069, 24.098936],
						[98.876591, 24.15137],
						[98.841482, 24.126794],
						[98.818692, 24.133348],
						[98.71891, 24.127887],
						[98.681954, 24.100029],
						[98.646229, 24.106038],
						[98.593875, 24.08036],
						[98.547063, 24.128433],
						[98.487933, 24.123517],
						[98.48239, 24.122425],
						[98.37768, 24.114232],
						[98.343187, 24.098936],
						[98.219999, 24.113685],
						[98.19721, 24.09839],
						[98.132536, 24.09238],
						[98.125761, 24.092927],
						[98.123297, 24.092927],
						[98.096196, 24.08637],
						[98.091268, 24.085824],
						[97.995182, 24.04648],
						[97.984095, 24.031177],
						[97.902175, 24.014231],
						[97.896015, 23.974319],
						[97.863371, 23.978693],
						[97.8104, 23.943146],
						[97.795617, 23.951897],
						[97.763588, 23.907041],
						[97.72848, 23.895551],
						[97.718009, 23.867643],
						[97.684132, 23.876946],
						[97.647176, 23.840823],
						[97.640401, 23.866001],
						[97.633009, 23.879682],
						[97.5283, 23.926736],
						[97.529531, 23.943146],
						[97.572647, 23.983068],
						[97.628698, 24.004938],
						[97.637321, 24.04812],
						[97.730944, 24.113685],
						[97.753733, 24.168843],
						[97.72848, 24.183585],
						[97.729712, 24.227252],
						[97.767284, 24.258357],
						[97.721089, 24.295999],
						[97.665038, 24.296544],
						[97.662574, 24.339083],
						[97.716161, 24.358711],
						[97.679821, 24.401228],
						[97.669966, 24.452993],
						[97.588662, 24.435559],
						[97.530147, 24.443187],
						[97.554785, 24.490577],
						[97.570799, 24.602719],
						[97.569567, 24.708236],
						[97.547394, 24.739221],
						[97.569567, 24.765852],
						[97.652103, 24.790846],
						[97.680437, 24.827243],
						[97.765436, 24.823984],
						[97.797465, 24.845709],
						[97.785762, 24.876117],
						[97.729712, 24.908689],
						[97.716777, 24.978147],
						[97.727864, 25.042686],
						[97.719857, 25.080634],
						[97.743262, 25.078466],
						[97.796233, 25.155954],
						[97.839349, 25.27074],
						[97.875689, 25.25721],
						[97.904023, 25.216609],
						[97.940363, 25.214985],
						[98.0075, 25.279399],
						[98.006884, 25.298338],
						[98.06971, 25.311864],
						[98.099891, 25.354055],
						[98.101123, 25.388662],
						[98.137464, 25.381633],
						[98.15779, 25.457307],
						[98.131304, 25.51025],
						[98.163949, 25.524292],
						[98.189818, 25.569108],
						[98.170724, 25.620383],
						[98.247717, 25.607971],
						[98.314854, 25.543193],
						[98.326557, 25.566409],
						[98.402317, 25.593939],
						[98.409709, 25.664084],
						[98.457752, 25.682963],
						[98.461448, 25.735267],
						[98.476846, 25.77731],
						[98.529201, 25.840884],
						[98.553839, 25.845731],
						[98.640686, 25.798864],
						[98.677642, 25.816105],
						[98.705976, 25.855426],
						[98.686881, 25.925955],
						[98.637606, 25.971696],
						[98.614201, 25.968468],
						[98.602498, 26.054523],
						[98.575396, 26.118485],
						[98.632679, 26.145887],
						[98.656084, 26.139977],
						[98.661012, 26.087852],
						[98.720142, 26.127082],
						[98.712751, 26.156093],
						[98.735541, 26.185097],
						[98.713367, 26.231274],
						[98.672715, 26.239863],
						[98.681338, 26.308016],
						[98.733693, 26.350926],
						[98.750323, 26.424372],
						[98.741084, 26.432947],
						[98.757098, 26.491881],
						[98.753403, 26.559349],
						[98.773113, 26.578083],
						[98.781736, 26.620893],
						[98.762642, 26.660478],
						[98.770033, 26.690424],
						[98.746012, 26.696841],
						[98.762026, 26.798916],
						[98.730613, 26.851253],
						[98.757098, 26.877947],
						[98.732461, 27.002257],
						[98.762642, 27.018252],
						[98.765722, 27.05077],
						[98.712751, 27.075817],
						[98.713983, 27.139744],
						[98.696121, 27.211086],
						[98.723222, 27.221198],
						[98.717062, 27.271211],
						[98.734925, 27.287168],
						[98.741084, 27.330241],
						[98.706591, 27.362136],
						[98.702896, 27.412618],
						[98.686881, 27.425367],
						[98.704128, 27.463607],
						[98.685034, 27.484315],
						[98.706591, 27.553313],
						[98.662244, 27.586734],
						[98.650541, 27.567637],
						[98.583404, 27.571351],
						[98.587099, 27.587265],
						[98.554454, 27.646126],
						[98.53536, 27.620676],
						[98.474998, 27.634462],
						[98.444201, 27.665209],
						[98.430035, 27.653547],
						[98.429419, 27.549068],
						[98.388767, 27.515104],
						[98.337644, 27.508734],
						[98.317318, 27.51935],
						[98.310542, 27.583552],
						[98.283441, 27.654608],
						[98.234166, 27.690648],
						[98.215688, 27.810874],
						[98.169492, 27.851096],
						[98.205217, 27.889716],
						[98.187355, 27.939426],
						[98.143007, 27.948942],
						[98.133152, 27.990698],
						[98.160253, 28.101089],
						[98.139311, 28.142259],
						[98.097427, 28.166531],
						[98.090036, 28.195544],
						[98.056775, 28.202401],
						[98.03337, 28.187105],
						[98.008116, 28.214003],
						[98.020435, 28.253548],
						[97.907718, 28.363141],
						[97.871378, 28.361561],
						[97.842429, 28.326798],
						[97.801161, 28.326798],
						[97.769748, 28.3742],
						[97.738335, 28.396313],
						[97.737103, 28.465782],
						[97.68598, 28.519958],
						[97.634857, 28.532051],
						[97.60406, 28.515225],
						[97.569567, 28.541515],
						[97.521524, 28.495766],
						[97.507974, 28.46473],
						[97.521524, 28.444736],
						[97.499966, 28.428948],
						[97.485184, 28.38631],
						[97.488879, 28.347341],
						[97.518445, 28.327852],
						[97.469169, 28.30309],
						[97.461162, 28.26778],
						[97.422358, 28.297293],
						[97.402032, 28.279903],
						[97.398336, 28.238786],
						[97.349677, 28.235623],
						[97.362612, 28.199236],
						[97.352757, 28.149646],
						[97.326887, 28.132759],
						[97.340438, 28.104785],
						[97.305945, 28.071522],
						[97.320728, 28.054095],
						[97.375547, 28.062545],
						[97.378626, 28.031382],
						[97.413119, 28.01342],
						[97.379242, 27.970087],
						[97.372467, 27.907699],
						[97.386634, 27.882839],
						[97.324424, 27.880723],
						[97.303482, 27.913516],
						[97.253591, 27.891832],
						[97.167975, 27.811932],
						[97.103301, 27.780697],
						[97.097758, 27.740979],
						[97.062649, 27.742568],
						[97.049099, 27.81405],
						[97.008447, 27.807698],
						[96.972722, 27.861149],
						[96.908049, 27.884426],
						[96.849534, 27.874375],
						[96.810114, 27.890245],
						[96.784245, 27.931495],
						[96.711564, 27.9574],
						[96.690622, 27.948942],
						[96.635188, 27.994926],
						[96.623485, 28.024514],
						[96.538485, 28.075218],
						[96.499681, 28.067297],
						[96.46334, 28.143314],
						[96.426384, 28.161782],
						[96.395587, 28.143842],
						[96.398667, 28.118509],
						[96.367254, 28.118509],
						[96.298269, 28.140148],
						[96.275479, 28.228241],
						[96.194175, 28.212949],
						[96.098088, 28.212421],
						[96.074683, 28.193434],
						[95.989067, 28.198181],
						[95.936096, 28.240368],
						[95.907763, 28.241422],
						[95.899756, 28.278322],
						[95.874502, 28.29782],
						[95.832003, 28.295186],
						[95.787655, 28.270416],
						[95.740228, 28.275159],
						[95.674322, 28.254075],
						[95.528345, 28.182885],
						[95.437802, 28.161782],
						[95.39715, 28.142259],
						[95.371896, 28.110063],
						[95.352802, 28.04089],
						[95.32878, 28.017646],
						[95.28628, 27.939955],
						[95.067006, 27.840512],
						[95.015267, 27.82887],
						[94.947514, 27.792345],
						[94.88592, 27.743098],
						[94.836645, 27.728796],
						[94.78121, 27.699127],
						[94.722696, 27.683759],
						[94.660486, 27.650367],
						[94.524979, 27.596282],
						[94.478168, 27.602116],
						[94.443675, 27.585143],
						[94.399944, 27.589386],
						[94.353132, 27.578778],
						[94.277372, 27.58143],
						[94.220705, 27.536333],
						[94.147409, 27.458297],
						[94.056866, 27.375423],
						[93.970634, 27.30525],
						[93.849294, 27.168499],
						[93.841903, 27.045973],
						[93.817265, 27.025183],
						[93.747048, 27.015587],
						[93.625092, 26.955323],
						[93.56781, 26.938252],
						[93.232739, 26.906769],
						[93.111399, 26.880082],
						[93.050421, 26.883819],
						[92.909371, 26.914241],
						[92.802813, 26.895028],
						[92.682089, 26.947855],
						[92.64698, 26.952656],
						[92.549046, 26.941453],
						[92.496691, 26.921711],
						[92.404916, 26.9025],
						[92.28604, 26.892359],
						[92.197961, 26.86994],
						[92.109265, 26.854991],
						[92.124664, 26.960124],
						[92.076005, 27.041175],
						[92.043976, 27.052902],
						[92.02673, 27.108318],
						[92.032273, 27.167967],
						[92.061222, 27.190327],
						[92.071077, 27.237694],
						[92.091403, 27.264296],
						[92.125896, 27.273339],
						[92.064918, 27.391365],
						[92.021802, 27.444489],
						[92.010715, 27.474758],
						[91.946657, 27.464138],
						[91.839484, 27.489624],
						[91.753868, 27.462545],
						[91.71876, 27.467324],
						[91.663325, 27.507142],
						[91.626985, 27.509265],
						[91.585101, 27.540578],
						[91.564775, 27.58196],
						[91.582637, 27.598933],
						[91.562311, 27.627569],
						[91.570934, 27.650897],
						[91.622673, 27.692238],
						[91.642383, 27.7664],
						[91.610355, 27.819343],
						[91.544449, 27.820401],
						[91.561079, 27.855329],
						[91.618978, 27.856916],
						[91.611586, 27.891303],
						[91.552456, 27.90717],
						[91.486551, 27.937311],
						[91.490246, 27.971672],
						[91.464993, 28.002852],
						[91.309776, 28.057791],
						[91.251878, 27.970615],
						[91.216153, 27.989113],
						[91.162567, 27.968501],
						[91.147784, 27.927794],
						[91.155175, 27.894476],
						[91.113292, 27.846333],
						[91.025828, 27.857445],
						[90.96485, 27.900294],
						[90.976553, 27.935725],
						[90.96177, 27.9537],
						[90.896481, 27.946299],
						[90.853365, 27.969029],
						[90.806554, 28.015005],
						[90.802242, 28.040362],
						[90.741264, 28.053038],
						[90.701844, 28.076274],
						[90.591591, 28.021345],
						[90.569417, 28.044059],
						[90.513983, 28.062016],
						[90.47949, 28.044587],
						[90.43699, 28.063073],
						[90.384019, 28.06096],
						[90.367389, 28.088946],
						[90.297172, 28.153868],
						[90.231882, 28.144897],
						[90.189999, 28.161782],
						[90.166593, 28.187632],
						[90.124709, 28.190797],
						[90.103151, 28.141731],
						[90.07297, 28.155451],
						[90.03355, 28.136981],
						[90.017536, 28.162837],
						[89.976268, 28.189215],
						[89.901739, 28.18183],
						[89.869094, 28.221386],
						[89.789638, 28.240895],
						[89.779167, 28.197127],
						[89.720037, 28.170224],
						[89.605472, 28.161782],
						[89.541414, 28.088418],
						[89.511233, 28.086307],
						[89.461958, 28.03191],
						[89.44348, 27.968501],
						[89.375727, 27.875962],
						[89.295655, 27.84845],
						[89.238988, 27.796581],
						[89.184786, 27.673689],
						[89.131815, 27.633402],
						[89.128735, 27.611131],
						[89.163228, 27.574534],
						[89.109025, 27.537925],
						[89.095474, 27.471572],
						[89.132431, 27.441302],
						[89.182938, 27.373829],
						[89.152757, 27.319076],
						[89.077612, 27.287168],
						[89.067757, 27.240354],
						[88.984605, 27.208957],
						[88.942105, 27.261636],
						[88.911924, 27.272807],
						[88.920548, 27.325456],
						[88.901453, 27.327583],
						[88.867577, 27.3818],
						[88.838012, 27.37808],
						[88.809063, 27.405711],
						[88.783193, 27.467324],
						[88.797976, 27.521473],
						[88.770874, 27.563924],
						[88.813374, 27.606889],
						[88.816454, 27.641354],
						[88.852178, 27.671039],
						[88.850331, 27.710783],
						[88.870657, 27.743098],
						[88.863265, 27.811932],
						[88.888519, 27.846863],
						[88.864497, 27.921448],
						[88.846635, 27.921448],
						[88.842939, 28.006023],
						[88.812142, 28.018175],
						[88.764099, 28.068353],
						[88.67602, 28.068353],
						[88.645223, 28.111119],
						[88.620585, 28.091586],
						[88.565151, 28.083139],
						[88.554064, 28.027684],
						[88.498013, 28.04089],
						[88.469064, 28.009721],
						[88.43334, 28.002852],
						[88.401311, 27.976958],
						[88.357579, 27.986471],
						[88.254101, 27.939426],
						[88.242398, 27.967444],
						[88.203594, 27.943127],
						[88.156783, 27.957929],
						[88.120442, 27.915103],
						[88.137689, 27.878607],
						[88.111819, 27.864852],
						[88.090877, 27.885484],
						[88.037291, 27.901881],
						[87.982472, 27.884426],
						[87.930733, 27.909285],
						[87.826639, 27.927794],
						[87.782292, 27.890774],
						[87.77798, 27.860091],
						[87.727473, 27.802933],
						[87.668343, 27.809815],
						[87.670191, 27.832045],
						[87.598126, 27.814579],
						[87.58088, 27.859562],
						[87.45954, 27.820931],
						[87.418272, 27.825694],
						[87.421967, 27.856916],
						[87.364069, 27.824106],
						[87.317258, 27.826753],
						[87.280917, 27.845275],
						[87.249504, 27.839454],
						[87.227946, 27.812991],
						[87.173744, 27.818284],
						[87.118309, 27.840512],
						[87.080737, 27.910872],
						[87.035157, 27.946299],
						[86.935375, 27.955286],
						[86.926752, 27.985942],
						[86.885484, 27.995983],
						[86.864542, 28.022401],
						[86.827586, 28.012363],
						[86.756753, 28.032967],
						[86.768456, 28.06941],
						[86.74813, 28.089474],
						[86.700086, 28.101617],
						[86.662514, 28.092114],
						[86.647732, 28.06941],
						[86.611391, 28.069938],
						[86.60092, 28.097922],
						[86.568891, 28.103201],
						[86.55842, 28.047757],
						[86.537478, 28.044587],
						[86.513457, 27.996511],
						[86.514689, 27.954757],
						[86.475884, 27.944713],
						[86.450015, 27.908757],
						[86.414906, 27.904526],
						[86.393349, 27.926736],
						[86.308965, 27.950528],
						[86.27324, 27.976958],
						[86.231972, 27.974315],
						[86.206103, 28.084195],
						[86.223965, 28.092642],
						[86.19132, 28.167058],
						[86.140198, 28.114814],
						[86.128495, 28.086835],
						[86.086611, 28.090002],
						[86.082915, 28.018175],
						[86.125415, 27.923035],
						[86.053966, 27.900823],
						[86.002227, 27.90717],
						[85.949256, 27.937311],
						[85.980053, 27.984357],
						[85.901213, 28.053566],
						[85.898749, 28.101617],
						[85.871648, 28.124843],
						[85.854402, 28.172334],
						[85.791576, 28.195544],
						[85.753388, 28.227714],
						[85.720743, 28.372093],
						[85.682555, 28.375779],
						[85.650526, 28.283592],
						[85.601251, 28.254075],
						[85.602483, 28.295712],
						[85.520563, 28.326798],
						[85.458969, 28.332593],
						[85.415853, 28.321003],
						[85.379512, 28.274105],
						[85.349947, 28.298347],
						[85.272339, 28.282538],
						[85.209513, 28.338914],
						[85.179948, 28.324164],
						[85.113427, 28.344708],
						[85.129441, 28.377885],
						[85.108499, 28.461047],
						[85.160238, 28.49261],
						[85.189803, 28.544669],
						[85.18426, 28.587244],
						[85.195963, 28.624022],
						[85.155926, 28.643983],
						[85.126361, 28.676016],
						[85.05676, 28.674441],
						[84.995782, 28.611414],
						[84.981616, 28.586193],
						[84.896616, 28.587244],
						[84.857196, 28.567798],
						[84.773428, 28.610363],
						[84.698284, 28.633478],
						[84.699515, 28.671816],
						[84.669334, 28.680742],
						[84.650856, 28.714338],
						[84.620059, 28.732182],
						[84.557233, 28.74635],
						[84.483321, 28.735331],
						[84.445133, 28.764189],
						[84.434046, 28.823978],
						[84.404481, 28.828173],
						[84.408176, 28.85386],
						[84.340423, 28.866963],
						[84.330568, 28.859101],
						[84.268358, 28.895261],
						[84.234481, 28.889497],
						[84.228322, 28.949738],
						[84.248648, 29.030353],
						[84.224626, 29.049189],
						[84.194445, 29.045004],
						[84.192597, 29.084236],
						[84.20738, 29.118749],
						[84.176583, 29.133909],
						[84.17104, 29.19453],
						[84.197525, 29.210202],
						[84.203068, 29.239972],
						[84.130388, 29.239972],
						[84.116837, 29.286438],
						[84.052163, 29.296877],
						[84.002272, 29.291658],
						[83.986874, 29.325057],
						[83.949301, 29.312533],
						[83.911729, 29.323491],
						[83.851367, 29.294789],
						[83.82057, 29.294267],
						[83.800244, 29.249372],
						[83.727563, 29.244672],
						[83.667201, 29.200277],
						[83.656114, 29.16736],
						[83.596368, 29.174153],
						[83.57789, 29.203934],
						[83.548941, 29.201322],
						[83.492274, 29.280174],
						[83.463941, 29.285916],
						[83.450391, 29.332883],
						[83.423289, 29.361053],
						[83.415898, 29.420496],
						[83.383253, 29.42206],
						[83.325355, 29.502826],
						[83.27608, 29.505951],
						[83.266841, 29.571035],
						[83.217565, 29.60018],
						[83.164595, 29.595496],
						[83.159667, 29.61735],
						[83.12887, 29.623593],
						[83.088834, 29.604863],
						[83.011226, 29.667804],
						[82.966878, 29.658963],
						[82.9484, 29.704718],
						[82.885574, 29.689122],
						[82.830756, 29.687562],
						[82.816589, 29.717192],
						[82.774089, 29.726548],
						[82.757459, 29.761881],
						[82.691553, 29.766037],
						[82.737749, 29.80655],
						[82.703872, 29.847566],
						[82.6238, 29.834588],
						[82.64351, 29.868846],
						[82.609017, 29.886489],
						[82.560974, 29.955476],
						[82.498148, 29.947698],
						[82.474743, 29.973622],
						[82.431011, 29.989692],
						[82.412533, 30.011978],
						[82.368185, 30.014051],
						[82.333693, 30.045138],
						[82.311519, 30.035813],
						[82.246845, 30.071555],
						[82.17786, 30.06793],
						[82.183403, 30.12178],
						[82.207425, 30.143519],
						[82.188947, 30.18543],
						[82.142135, 30.200948],
						[82.114418, 30.226806],
						[82.11873, 30.279019],
						[82.132896, 30.30434],
						[82.104563, 30.346182],
						[82.060215, 30.332237],
						[82.022027, 30.339468],
						[81.99123, 30.322939],
						[81.954274, 30.355995],
						[81.939491, 30.344633],
						[81.872354, 30.373035],
						[81.759021, 30.385426],
						[81.723913, 30.407623],
						[81.63029, 30.446842],
						[81.613044, 30.412784],
						[81.566232, 30.428782],
						[81.555761, 30.369421],
						[81.494783, 30.381296],
						[81.454131, 30.412268],
						[81.418407, 30.420525],
						[81.406704, 30.40401],
						[81.432573, 30.379231],
						[81.406088, 30.369421],
						[81.399929, 30.319323],
						[81.427646, 30.305373],
						[81.406088, 30.291938],
						[81.419023, 30.270232],
						[81.397465, 30.240767],
						[81.393769, 30.199396],
						[81.335871, 30.149729],
						[81.269349, 30.153351],
						[81.293371, 30.094859],
						[81.2829, 30.061197],
						[81.247792, 30.032705],
						[81.256415, 30.011978],
						[81.225618, 30.005759],
						[81.131995, 30.016124],
						[81.09627, 30.052909],
						[81.110437, 30.085538],
						[81.085799, 30.100554],
						[81.082104, 30.151281],
						[81.038372, 30.205086],
						[81.034677, 30.246971],
						[80.996488, 30.267648],
						[80.933662, 30.266614],
						[80.910873, 30.30279],
						[80.81725, 30.321389],
						[80.719316, 30.414848],
						[80.692214, 30.416913],
						[80.633084, 30.458707],
						[80.585041, 30.463866],
						[80.549316, 30.448905],
						[80.504969, 30.483466],
						[80.446454, 30.495327],
						[80.43044, 30.515952],
						[80.357759, 30.520592],
						[80.322035, 30.564403],
						[80.261673, 30.566465],
						[80.214245, 30.586044],
						[80.143412, 30.55822],
						[80.04363, 30.603559],
						[80.014065, 30.661748],
						[79.970333, 30.685941],
						[79.955551, 30.738422],
						[79.961094, 30.771337],
						[79.900732, 30.7991],
						[79.913051, 30.833022],
						[79.890877, 30.855116],
						[79.835443, 30.851006],
						[79.75845, 30.936769],
						[79.729501, 30.941389],
						[79.668523, 30.980392],
						[79.660516, 30.956787],
						[79.59769, 30.925989],
						[79.550879, 30.957813],
						[79.505915, 31.027584],
						[79.427075, 31.018353],
						[79.424611, 31.061425],
						[79.404901, 31.071678],
						[79.35809, 31.031174],
						[79.316206, 31.01784],
						[79.33222, 30.969103],
						[79.227511, 30.949088],
						[79.205953, 31.0004],
						[79.181931, 31.015788],
						[79.096931, 30.992192],
						[79.059359, 31.028097],
						[79.010084, 31.043994],
						[78.97436, 31.115751],
						[78.997765, 31.158779],
						[78.930628, 31.220726],
						[78.923852, 31.246824],
						[78.884432, 31.277006],
						[78.865338, 31.312804],
						[78.859179, 31.289281],
						[78.795121, 31.301043],
						[78.755085, 31.355742],
						[78.760013, 31.392531],
						[78.792041, 31.435944],
						[78.755701, 31.478316],
						[78.729832, 31.478316],
						[78.740303, 31.532912],
						[78.779723, 31.545154],
						[78.833925, 31.584927],
						[78.845628, 31.609905],
						[78.806824, 31.64099],
						[78.798817, 31.675629],
						[78.763092, 31.668499],
						[78.706426, 31.778453],
						[78.654687, 31.819144],
						[78.665158, 31.851684],
						[78.739687, 31.885228],
						[78.768636, 31.92638],
						[78.762476, 31.947203],
						[78.705194, 31.988835],
						[78.60726, 32.023851],
						[78.609107, 32.052768],
						[78.527188, 32.11463],
						[78.509941, 32.147065],
						[78.469905, 32.127808],
						[78.429869, 32.194683],
						[78.430485, 32.212407],
						[78.475449, 32.236708],
						[78.508709, 32.297939],
						[78.480992, 32.329297],
						[78.483456, 32.357106],
						[78.458818, 32.379853],
						[78.472985, 32.435431],
						[78.426174, 32.502584],
						[78.395377, 32.530339],
						[78.424942, 32.565652],
						[78.500086, 32.580782],
						[78.518564, 32.605993],
						[78.577695, 32.615067],
						[78.588782, 32.637748],
						[78.628202, 32.630188],
						[78.675013, 32.658408],
						[78.6861, 32.680071],
						[78.741534, 32.703743],
						[78.74215, 32.654881],
						[78.781571, 32.608009],
						[78.760629, 32.563635],
						[78.782186, 32.480373],
						[78.81052, 32.436441],
						[78.87273, 32.40512],
						[78.904142, 32.374798],
						[78.970664, 32.331826],
						[79.005772, 32.375304],
						[79.067982, 32.380863],
						[79.103091, 32.369744],
						[79.124649, 32.416235],
						[79.135736, 32.472295],
						[79.180083, 32.492994],
						[79.190554, 32.511669],
						[79.252148, 32.516715],
						[79.272474, 32.561113],
						[79.308199, 32.596918],
						[79.299575, 32.637244],
						[79.27309, 32.678056],
						[79.301423, 32.728919],
						[79.275554, 32.778746],
						[79.225047, 32.784281],
						[79.237982, 32.846145],
						[79.227511, 32.89038],
						[79.255844, 32.942628],
						[79.204721, 32.964724],
						[79.162837, 33.01191],
						[79.139431, 33.117735],
						[79.162221, 33.165841],
						[79.152366, 33.184375],
						[79.10925, 33.200401],
						[79.072294, 33.22844],
						[79.083997, 33.245459],
						[79.041497, 33.268479],
						[79.022403, 33.323504],
						[78.9682, 33.334505],
						[78.949722, 33.376495],
						[78.896751, 33.41247],
						[78.84994, 33.419963],
						[78.816679, 33.480882],
						[78.74215, 33.55323],
						[78.755085, 33.623025],
						[78.713201, 33.623025],
						[78.684868, 33.654415],
						[78.692259, 33.676331],
						[78.779723, 33.73259],
						[78.758165, 33.790802],
						[78.766172, 33.823124],
						[78.756317, 33.8773],
						[78.762476, 33.90959],
						[78.734143, 33.918529],
						[78.744614, 33.980585],
						[78.736607, 33.999937],
						[78.656535, 34.030196],
						[78.661462, 34.086718],
						[78.737223, 34.089692],
						[78.801897, 34.137258],
						[78.828998, 34.125369],
						[78.878273, 34.163012],
						[78.910302, 34.143202],
						[78.9257, 34.155584],
						[78.941099, 34.212022],
						[78.958345, 34.230827],
						[78.981751, 34.31836],
						[79.019939, 34.313417],
						[79.039649, 34.33467],
						[78.973128, 34.362833],
						[78.958961, 34.386049],
						[78.899831, 34.354929],
						[78.878273, 34.391481],
						[78.809288, 34.432955],
						[78.742766, 34.45467],
						[78.758781, 34.481807],
						[78.715049, 34.502031],
						[78.708274, 34.522249],
						[78.634977, 34.538026],
						[78.58139, 34.505483],
						[78.562912, 34.51288],
						[78.559832, 34.55725],
						[78.542586, 34.574499],
						[78.492695, 34.578441],
						[78.436029, 34.543942],
						[78.427405, 34.594207],
						[78.397224, 34.605538],
						[78.346101, 34.60406],
						[78.280812, 34.623269],
						[78.265413, 34.651335],
						[78.267261, 34.705472],
						[78.213059, 34.717771],
						[78.21429, 34.760556],
						[78.230921, 34.776288],
						[78.237696, 34.882398],
						[78.206283, 34.891726],
						[78.182262, 34.936874],
						[78.201972, 34.974642],
						[78.160704, 34.990823],
						[78.123131, 35.036897],
						[78.150849, 35.069721],
						[78.124979, 35.108407],
						[78.078784, 35.100084],
						[78.062769, 35.114772],
						[78.060306, 35.180344],
						[78.01719, 35.228267],
						[78.020885, 35.315237],
						[78.013494, 35.366008],
						[78.046755, 35.384063],
						[78.107117, 35.437229],
						[78.113892, 35.466967],
						[78.140378, 35.494745],
						[78.048603, 35.491334],
						[78.029509, 35.469404],
						[78.009799, 35.491821],
						[77.951284, 35.478664],
						[77.917408, 35.490847],
						[77.914944, 35.465017],
						[77.870596, 35.495232],
						[77.85643, 35.487436],
						[77.816394, 35.518616],
						[77.797299, 35.491334],
						[77.757879, 35.497181],
						[77.735706, 35.461605],
						[77.690742, 35.448443],
						[77.657481, 35.477689],
						[77.639619, 35.45478],
						[77.590344, 35.460143],
						[77.578025, 35.47574],
						[77.518895, 35.482075],
						[77.451758, 35.46063],
						[77.396939, 35.467942],
						[77.355055, 35.494257],
						[77.331649, 35.530793],
						[77.307628, 35.540533],
						[77.195527, 35.519103],
						[77.093281, 35.569746],
						[77.072339, 35.591162],
						[76.99781, 35.611113],
						[76.967013, 35.591649],
						[76.906651, 35.615005],
						[76.848753, 35.668018],
						[76.769297, 35.653917],
						[76.69292, 35.747714],
						[76.593754, 35.771996],
						[76.566037, 35.819082],
						[76.587595, 35.840431],
						[76.579587, 35.866625],
						[76.59745, 35.895718],
						[76.55803, 35.923347],
						[76.51553, 35.881173],
						[76.471798, 35.886021],
						[76.431762, 35.851589],
						[76.369552, 35.86323],
						[76.365857, 35.82442],
						[76.298719, 35.841401],
						[76.228502, 35.837035],
						[76.221727, 35.823449],
						[76.160133, 35.82442],
						[76.146582, 35.839946],
						[76.16506, 35.908807],
						[76.117017, 35.975186],
						[76.097307, 36.022635],
						[76.044336, 36.026991],
						[76.028322, 36.016827],
						[75.982742, 36.031347],
						[75.949482, 36.070056],
						[75.936547, 36.13485],
						[75.96796, 36.159013],
						[76.016619, 36.165294],
						[76.011691, 36.229044],
						[76.060967, 36.225182],
						[76.055423, 36.252695],
						[75.998757, 36.312034],
						[75.991365, 36.35205],
						[76.035097, 36.409386],
						[75.991981, 36.505654],
						[75.924228, 36.566242],
						[75.947018, 36.590752],
						[75.871257, 36.666636],
						[75.8072, 36.707908],
						[75.724048, 36.750597],
						[75.634121, 36.771693],
						[75.588541, 36.762584],
						[75.537418, 36.773131],
						[75.536802, 36.729975],
						[75.504773, 36.743404],
						[75.458578, 36.720861],
						[75.425933, 36.778883],
						[75.434556, 36.83303],
						[75.430245, 36.873255],
						[75.396368, 36.904367],
						[75.413614, 36.954599],
						[75.345861, 36.960816],
						[75.288579, 36.974682],
						[75.244847, 36.963207],
						[75.16847, 36.991892],
						[75.172166, 37.013877],
						[75.063145, 37.006231],
						[75.032348, 37.016745],
						[75.005862, 36.99476],
						[74.927638, 36.978029],
						[74.938725, 36.94312],
						[74.893762, 36.939772],
						[74.86974, 36.990458],
						[74.84387, 37.0134],
						[74.84695, 37.056873],
						[74.806914, 37.054485],
						[74.792747, 37.027257],
						[74.739161, 37.028212],
						[74.70898, 37.084569],
						[74.632603, 37.066425],
						[74.617205, 37.043499],
						[74.56793, 37.032512],
						[74.530357, 37.082182],
						[74.498944, 37.072155],
						[74.496481, 37.116072],
						[74.465068, 37.147085],
						[74.487858, 37.161871],
						[74.477387, 37.19954],
						[74.511263, 37.240048],
						[74.54514, 37.2491],
						[74.578401, 37.231472],
						[74.598727, 37.258151],
						[74.642458, 37.261485],
						[74.665864, 37.23576],
						[74.727458, 37.282916],
						[74.753943, 37.281011],
						[74.800139, 37.248147],
						[74.816153, 37.216699],
						[74.911008, 37.233378],
						[74.927022, 37.277678],
						[75.018181, 37.293867],
						[75.078543, 37.318144],
						[75.125971, 37.322427],
						[75.140137, 37.355258],
						[75.125971, 37.388075],
						[75.153072, 37.414223],
						[75.129666, 37.459367],
						[75.090862, 37.486915],
						[75.078543, 37.511129],
						[75.035428, 37.500685],
						[75.002167, 37.511604],
						[75.000935, 37.53059],
						[74.940573, 37.559061],
						[74.891914, 37.668097],
						[74.920863, 37.684675],
						[74.923327, 37.717347],
						[74.949196, 37.725395],
						[75.006478, 37.770823],
						[74.989848, 37.797783],
						[74.917167, 37.845057],
						[74.936877, 37.876241],
						[74.919015, 37.908357],
						[74.911008, 37.966884],
						[74.92579, 38.01735],
						[74.879595, 38.021122],
						[74.821697, 38.10311],
						[74.80445, 38.167128],
						[74.816769, 38.215576],
						[74.793363, 38.271039],
						[74.806914, 38.285602],
						[74.789668, 38.324581],
						[74.834015, 38.361193],
						[74.868508, 38.403883],
						[74.862965, 38.484035],
						[74.821697, 38.491062],
						[74.78474, 38.538357],
						[74.717603, 38.542102],
						[74.639995, 38.599653],
						[74.613509, 38.593105],
						[74.546988, 38.607604],
						[74.506336, 38.637528],
						[74.455829, 38.632853],
						[74.421952, 38.647812],
						[74.353583, 38.655757],
						[74.229779, 38.656224],
						[74.147859, 38.676785],
						[74.11275, 38.611345],
						[74.088113, 38.610878],
						[74.068403, 38.585621],
						[74.090577, 38.542102],
						[74.034526, 38.541634],
						[74.011736, 38.52478],
						[73.926121, 38.536016],
						[73.89902, 38.579071],
						[73.852208, 38.584217],
						[73.799237, 38.610878],
						[73.809092, 38.634256],
						[73.757353, 38.719755],
						[73.769056, 38.775765],
						[73.729636, 38.837324],
						[73.699455, 38.857832],
						[73.70931, 38.893241],
						[73.742571, 38.933754],
						[73.767824, 38.941202],
						[73.826339, 38.916993],
						[73.846665, 38.962145],
						[73.839889, 39.008199],
						[73.820179, 39.041674],
						[73.780143, 39.026798],
						[73.743187, 39.029588],
						[73.720397, 39.071881],
						[73.719781, 39.108112],
						[73.688368, 39.154999],
						[73.657571, 39.166136],
						[73.639709, 39.220402],
						[73.623079, 39.235237],
						[73.580579, 39.237555],
						[73.564564, 39.266288],
						[73.542391, 39.269531],
						[73.554709, 39.295935],
						[73.554094, 39.350102],
						[73.502355, 39.383877],
						[73.592898, 39.412087],
						[73.61076, 39.465702],
						[73.6471, 39.474479],
						[73.745651, 39.462005],
						[73.836194, 39.472169],
						[73.868223, 39.482794],
						[73.893476, 39.528046],
						[73.883621, 39.540969],
						[73.914418, 39.564041],
						[73.916266, 39.586644],
						[73.953838, 39.600018],
						[73.924273, 39.722108],
						[73.905795, 39.741899],
						[73.841737, 39.756163],
						[73.845433, 39.831115],
						[73.907027, 39.873843],
						[73.910722, 39.934443],
						[73.980324, 40.004617],
						[73.943367, 40.016076],
						[74.008041, 40.050901],
						[74.023439, 40.085251],
						[74.113366, 40.086624],
						[74.126301, 40.104479],
						[74.26304, 40.125074],
						[74.280902, 40.09807],
						[74.316626, 40.106767],
						[74.356662, 40.089371],
						[74.433039, 40.13148],
						[74.485394, 40.182251],
						[74.534669, 40.207851],
						[74.577169, 40.260391],
						[74.618437, 40.27957],
						[74.673255, 40.278656],
						[74.697893, 40.310153],
						[74.700357, 40.346195],
						[74.824776, 40.344371],
						[74.862965, 40.32658],
						[74.908544, 40.338897],
						[74.795211, 40.443278],
						[74.814921, 40.461039],
						[74.819233, 40.505647],
						[74.844486, 40.521117],
						[74.891914, 40.507467],
						[74.963363, 40.464681],
						[74.995392, 40.455119],
						[75.021877, 40.466958],
						[75.051442, 40.449654],
						[75.102565, 40.44009],
						[75.13521, 40.463315],
						[75.206659, 40.447833],
						[75.242383, 40.448743],
						[75.268869, 40.483802],
						[75.292274, 40.483802],
						[75.355716, 40.537947],
						[75.432093, 40.563412],
						[75.467817, 40.599773],
						[75.550353, 40.64883],
						[75.599628, 40.659727],
						[75.636584, 40.624306],
						[75.627345, 40.605226],
						[75.631041, 40.548862],
						[75.646439, 40.516567],
						[75.733287, 40.474242],
						[75.717272, 40.443278],
						[75.686475, 40.418223],
						[75.669845, 40.363982],
						[75.688323, 40.343915],
						[75.709265, 40.280939],
						[75.739446, 40.299199],
						[75.785642, 40.301025],
						[75.831221, 40.327492],
						[75.84046, 40.312434],
						[75.890351, 40.30924],
						[75.921764, 40.291439],
						[75.932235, 40.339353],
						[75.986438, 40.381763],
						[76.026474, 40.355317],
						[76.048648, 40.357141],
						[76.048648, 40.388601],
						[76.081293, 40.39635],
						[76.144118, 40.393615],
						[76.176147, 40.381307],
						[76.22419, 40.401819],
						[76.279625, 40.439179],
						[76.283321, 40.415034],
						[76.327668, 40.391336],
						[76.333212, 40.343459],
						[76.381871, 40.39088],
						[76.390494, 40.37766],
						[76.442233, 40.391336],
						[76.470566, 40.422779],
						[76.508754, 40.429613],
						[76.539551, 40.464226],
						[76.543247, 40.513837],
						[76.556798, 40.542495],
						[76.601145, 40.578868],
						[76.611, 40.601591],
						[76.657196, 40.620218],
						[76.654732, 40.652917],
						[76.676906, 40.696036],
						[76.646725, 40.73686],
						[76.646725, 40.759983],
						[76.693536, 40.779472],
						[76.731724, 40.818887],
						[76.741579, 40.912119],
						[76.761905, 40.954167],
						[76.817956, 40.975406],
						[76.85368, 40.97631],
						[76.885709, 41.027347],
						[76.940528, 41.028701],
						[77.002122, 41.073381],
						[77.023064, 41.059394],
						[77.091433, 41.062553],
						[77.108063, 41.038181],
						[77.169041, 41.009285],
						[77.236795, 41.027798],
						[77.296541, 41.004769],
						[77.363062, 41.04089],
						[77.415417, 41.038633],
						[77.473931, 41.022832],
						[77.476395, 40.999349],
						[77.540453, 41.006575],
						[77.591576, 40.992122],
						[77.597119, 41.005221],
						[77.654402, 41.016059],
						[77.684583, 41.00793],
						[77.737553, 41.032313],
						[77.780669, 41.022832],
						[77.796068, 41.049014],
						[77.829328, 41.059394],
						[77.807155, 41.091876],
						[77.814546, 41.13426],
						[77.836104, 41.153189],
						[77.905089, 41.185174],
						[77.972842, 41.173013],
						[78.094798, 41.224347],
						[78.129291, 41.228398],
						[78.136682, 41.279239],
						[78.165015, 41.340825],
						[78.149617, 41.368228],
						[78.163783, 41.383497],
						[78.235232, 41.399211],
						[78.324544, 41.384395],
						[78.338094, 41.397415],
						[78.385522, 41.394721],
						[78.391681, 41.408189],
						[78.454507, 41.412228],
						[78.527188, 41.440947],
						[78.580774, 41.481759],
						[78.650375, 41.467411],
						[78.675629, 41.50238],
						[78.707042, 41.522098],
						[78.696571, 41.54181],
						[78.739071, 41.555695],
						[78.825302, 41.560173],
						[78.86657, 41.593749],
						[78.891824, 41.597777],
						[78.957729, 41.65146],
						[78.99407, 41.664427],
						[79.021787, 41.657273],
						[79.043345, 41.681414],
						[79.10925, 41.697503],
						[79.138199, 41.722968],
						[79.21704, 41.725648],
						[79.271858, 41.767174],
						[79.276786, 41.78101],
						[79.326061, 41.809565],
						[79.356242, 41.795735],
						[79.415372, 41.836769],
						[79.457256, 41.847915],
						[79.500988, 41.835432],
						[79.550879, 41.834094],
						[79.616784, 41.856385],
						[79.640806, 41.884907],
						[79.724574, 41.896935],
						[79.776313, 41.89248],
						[79.822508, 41.963275],
						[79.854537, 41.984186],
						[79.852689, 42.015319],
						[79.923522, 42.042436],
						[80.089826, 42.047325],
						[80.14218, 42.03488],
						[80.193303, 42.081535],
						[80.16805, 42.096635],
						[80.139717, 42.151232],
						[80.163738, 42.152563],
						[80.168666, 42.200462],
						[80.233339, 42.210215],
						[80.28631, 42.233261],
						[80.29247, 42.259842],
						[80.272144, 42.281984],
						[80.283847, 42.320493],
						[80.229028, 42.358536],
						[80.239499, 42.389927],
						[80.206238, 42.431462],
						[80.225948, 42.485769],
						[80.265368, 42.502097],
						[80.221637, 42.533415],
						[80.180985, 42.590718],
						[80.163738, 42.629919],
						[80.179753, 42.670415],
						[80.228412, 42.692852],
						[80.225948, 42.713083],
						[80.259209, 42.790865],
						[80.262289, 42.828623],
						[80.280151, 42.838278],
						[80.338049, 42.831695],
						[80.407034, 42.834767],
						[80.450766, 42.861971],
						[80.503737, 42.882146],
						[80.602903, 42.894424],
						[80.5912, 42.923354],
						[80.487106, 42.948766],
						[80.397795, 42.996933],
						[80.378701, 43.031502],
						[80.416889, 43.05687],
						[80.482795, 43.06955],
						[80.556092, 43.104515],
						[80.593048, 43.133347],
						[80.650946, 43.147321],
						[80.706997, 43.143828],
						[80.73225, 43.131163],
						[80.752576, 43.148194],
						[80.79446, 43.137277],
						[80.804315, 43.178314],
						[80.789533, 43.201876],
						[80.788917, 43.242433],
						[80.769207, 43.265535],
						[80.777214, 43.308227],
						[80.69283, 43.32042],
						[80.686055, 43.333916],
						[80.735946, 43.389609],
						[80.746417, 43.439167],
						[80.761199, 43.446554],
						[80.75504, 43.494329],
						[80.522215, 43.816473],
						[80.511128, 43.906657],
						[80.475404, 43.938124],
						[80.485259, 43.95579],
						[80.457541, 43.981203],
						[80.458773, 44.047054],
						[80.449534, 44.078017],
						[80.3941, 44.127009],
						[80.407034, 44.149772],
						[80.400875, 44.198704],
						[80.413194, 44.264741],
						[80.399027, 44.30587],
						[80.383013, 44.401297],
						[80.350368, 44.484615],
						[80.411962, 44.605321],
						[80.400259, 44.628751],
						[80.313412, 44.704938],
						[80.238883, 44.7228],
						[80.200695, 44.756808],
						[80.178521, 44.796741],
						[80.18776, 44.825612],
						[80.169898, 44.84471],
						[80.115695, 44.815424],
						[80.087978, 44.817122],
						[79.999283, 44.793768],
						[79.991891, 44.830281],
						[79.953703, 44.849377],
						[79.969102, 44.877797],
						[79.887798, 44.90917],
						[79.944464, 44.937985],
						[79.951855, 44.957892],
						[79.98142, 44.964244],
						[80.056565, 45.011227],
						[80.060876, 45.026033],
						[80.111999, 45.052675],
						[80.136021, 45.041259],
						[80.144644, 45.059017],
						[80.195767, 45.030686],
						[80.24381, 45.031532],
						[80.291854, 45.06578],
						[80.328194, 45.070007],
						[80.358375, 45.040836],
						[80.404571, 45.049293],
						[80.443991, 45.077614],
						[80.445839, 45.097895],
						[80.493882, 45.127037],
						[80.519135, 45.108878],
						[80.599207, 45.105921],
						[80.686055, 45.129148],
						[80.731634, 45.156164],
						[80.816634, 45.152788],
						[80.862214, 45.127037],
						[80.897938, 45.127459],
						[80.93551, 45.160384],
						[80.966307, 45.168402],
						[81.024821, 45.162916],
						[81.080872, 45.182745],
						[81.111669, 45.218168],
						[81.170183, 45.211001],
						[81.175111, 45.227863],
						[81.236705, 45.247248],
						[81.284748, 45.23882],
						[81.327864, 45.260729],
						[81.382066, 45.257781],
						[81.398697, 45.275471],
						[81.437501, 45.28263],
						[81.462754, 45.264099],
						[81.52866, 45.285999],
						[81.536667, 45.304101],
						[81.575471, 45.30789],
						[81.582863, 45.336503],
						[81.645072, 45.359216],
						[81.677101, 45.35459],
						[81.78797, 45.3836],
						[81.832318, 45.319673],
						[81.879745, 45.284314],
						[81.921013, 45.233342],
						[81.993078, 45.237978],
						[82.052824, 45.255674],
						[82.09594, 45.249776],
						[82.091012, 45.222383],
						[82.109491, 45.211422],
						[82.206809, 45.236713],
						[82.294272, 45.247669],
						[82.344779, 45.219011],
						[82.487061, 45.181058],
						[82.562822, 45.204676],
						[82.58746, 45.224069],
						[82.60101, 45.346178],
						[82.546808, 45.426038],
						[82.448257, 45.461309],
						[82.281954, 45.53891],
						[82.266555, 45.620172],
						[82.288729, 45.655321],
						[82.289961, 45.71636],
						[82.340468, 45.772742],
						[82.349707, 45.822811],
						[82.336156, 45.882418],
						[82.342932, 45.935303],
						[82.401446, 45.972333],
						[82.461808, 45.97982],
						[82.518474, 46.153798],
						[82.609017, 46.294985],
						[82.726662, 46.494756],
						[82.774089, 46.600124],
						[82.788872, 46.677784],
						[82.829524, 46.772551],
						[82.878183, 46.797138],
						[82.876335, 46.823762],
						[82.923762, 46.932169],
						[82.937929, 47.014248],
						[82.993364, 47.065229],
						[83.031552, 47.168265],
						[83.02724, 47.21544],
						[83.108544, 47.221944],
						[83.15474, 47.236168],
						[83.17445, 47.218286],
						[83.207094, 47.213814],
						[83.221877, 47.186977],
						[83.257602, 47.173147],
						[83.306261, 47.179656],
						[83.324739, 47.167858],
						[83.370318, 47.178436],
						[83.418978, 47.119012],
						[83.463325, 47.132042],
						[83.53847, 47.083977],
						[83.566803, 47.080717],
						[83.576042, 47.059114],
						[83.700462, 47.032199],
						[83.69923, 47.015472],
						[83.766367, 47.026896],
						[83.88586, 46.982003],
						[83.932671, 46.970161],
						[83.951765, 46.98731],
						[84.002888, 46.990576],
						[84.038613, 46.973428],
						[84.086656, 46.965261],
						[84.150098, 46.977512],
						[84.195061, 47.003638],
						[84.2893, 46.994658],
						[84.336727, 47.00527],
						[84.37122, 46.993434],
						[84.425422, 47.008943],
						[84.506726, 46.97302],
						[84.563393, 46.991801],
						[84.668718, 46.995067],
						[84.699515, 47.008535],
						[84.748175, 47.009759],
						[84.781435, 46.979962],
						[84.849189, 46.957092],
						[84.867051, 46.927673],
						[84.934188, 46.863878],
						[84.95513, 46.861013],
						[84.979768, 46.883106],
						[84.987159, 46.918272],
						[85.082014, 46.939933],
						[85.102956, 46.968936],
						[85.175637, 46.997924],
						[85.213825, 47.041172],
						[85.276651, 47.068898],
						[85.325926, 47.044842],
						[85.355491, 47.054629],
						[85.441106, 47.063191],
						[85.545816, 47.057891],
						[85.547048, 47.096609],
						[85.582772, 47.142626],
						[85.641903, 47.18413],
						[85.682555, 47.222757],
						[85.682555, 47.249982],
						[85.701033, 47.28856],
						[85.675779, 47.321837],
						[85.701649, 47.384275],
						[85.685018, 47.428829],
						[85.614801, 47.498015],
						[85.617881, 47.550552],
						[85.547048, 48.008205],
						[85.531649, 48.046227],
						[85.551975, 48.081423],
						[85.55136, 48.127781],
						[85.576613, 48.15853],
						[85.587084, 48.191654],
						[85.622193, 48.202824],
						[85.633895, 48.232731],
						[85.678243, 48.266205],
						[85.695489, 48.302445],
						[85.695489, 48.335078],
						[85.758315, 48.403064],
						[85.791576, 48.418954],
						[85.916612, 48.438015],
						[86.053966, 48.441192],
						[86.225813, 48.432456],
						[86.270161, 48.452307],
						[86.305269, 48.491984],
						[86.38103, 48.49357],
						[86.416138, 48.481671],
						[86.579978, 48.538763],
						[86.594761, 48.576789],
						[86.635413, 48.612016],
						[86.640956, 48.629027],
						[86.693311, 48.64366],
						[86.70255, 48.666195],
						[86.771535, 48.717156],
						[86.780774, 48.731369],
						[86.754289, 48.78463],
						[86.770303, 48.810255],
						[86.818963, 48.831139],
						[86.821426, 48.850439],
						[86.782006, 48.887049],
						[86.757985, 48.894919],
						[86.730267, 48.959797],
						[86.732115, 48.994757],
						[86.772151, 49.02773],
						[86.836209, 49.051269],
						[86.84976, 49.066563],
						[86.854071, 49.109284],
						[86.887948, 49.132001],
						[86.953853, 49.131218],
						[87.000049, 49.142572],
						[87.088128, 49.133567],
						[87.112766, 49.15549],
						[87.211932, 49.140615],
						[87.239033, 49.114376],
						[87.304939, 49.112418],
						[87.388707, 49.097921],
						[87.43675, 49.075188],
						[87.511894, 49.10184],
						[87.49588, 49.132001],
						[87.517438, 49.145704],
						[87.563017, 49.142572],
						[87.602437, 49.152359],
						[87.67635, 49.15549],
						[87.700372, 49.175839],
						[87.762582, 49.172709],
						[87.793379, 49.18249],
						[87.821096, 49.173883],
						[87.82048, 49.148445],
						[87.845733, 49.146096],
						[87.867291, 49.108892],
						[87.844502, 49.090084],
						[87.858052, 49.07362],
						[87.835263, 49.054406],
						[87.883306, 49.023806],
						[87.883922, 48.993971],
						[87.911639, 48.979833],
						[87.871603, 48.963726],
						[87.87653, 48.949186],
						[87.814321, 48.945256],
						[87.793995, 48.927565],
						[87.760118, 48.925992],
						[87.742256, 48.881146],
						[87.78106, 48.872094],
						[87.792147, 48.849258],
						[87.829103, 48.825623],
						[87.803234, 48.824835],
						[87.826639, 48.800795],
						[87.872219, 48.799612],
						[87.93874, 48.757809],
						[87.96153, 48.773588],
						[88.029283, 48.750313],
						[88.064392, 48.712813],
						[88.090877, 48.71992],
						[88.089645, 48.69504],
						[88.02682, 48.65315],
						[88.010805, 48.618742],
						[87.96153, 48.599353],
						[87.973233, 48.575997],
						[88.041602, 48.548272],
						[88.10874, 48.545895],
						[88.130297, 48.521721],
						[88.151855, 48.526478],
						[88.196819, 48.493967],
						[88.229464, 48.498329],
						[88.318159, 48.478497],
						[88.363123, 48.460641],
						[88.360659, 48.433251],
						[88.438267, 48.393528],
						[88.462289, 48.392335],
						[88.503557, 48.412996],
						[88.523267, 48.403461],
						[88.535586, 48.368884],
						[88.573158, 48.369679],
						[88.573774, 48.351785],
						[88.605803, 48.337863],
						[88.575006, 48.277757],
						[88.594716, 48.259831],
						[88.601491, 48.221567],
						[88.638447, 48.183674],
						[88.668628, 48.171303],
						[88.700657, 48.180881],
						[88.721599, 48.160526],
						[88.79736, 48.133772],
						[88.824461, 48.107005],
						[88.939026, 48.115396],
						[88.953808, 48.090618],
						[89.027105, 48.051028],
						[89.044967, 48.009806],
						[89.078228, 47.98698],
						[89.156452, 47.996992],
						[89.231597, 47.98017],
						[89.282104, 47.994189],
						[89.308589, 48.021816],
						[89.359712, 48.026219],
						[89.38127, 48.046227],
						[89.498299, 48.02822],
						[89.569132, 48.037825],
						[89.599313, 48.015811],
						[89.595617, 47.973359],
						[89.645508, 47.947711],
						[89.651052, 47.913627],
						[89.735435, 47.89758],
						[89.761921, 47.835751],
						[89.86971, 47.834144],
						[89.957789, 47.842982],
						[89.960253, 47.885942],
						[90.040941, 47.874704],
						[90.066195, 47.883534],
						[90.086521, 47.86547],
						[90.070506, 47.820483],
						[90.07605, 47.777469],
						[90.13518, 47.723147],
						[90.180144, 47.72516],
						[90.216484, 47.70543],
						[90.331665, 47.681663],
						[90.384635, 47.644179],
						[90.346447, 47.637324],
						[90.376012, 47.603036],
						[90.398186, 47.547724],
						[90.468403, 47.497611],
						[90.474562, 47.462422],
						[90.459164, 47.43895],
						[90.468403, 47.404937],
						[90.507823, 47.400076],
						[90.526301, 47.379007],
						[90.488113, 47.317374],
						[90.521374, 47.2845],
						[90.56141, 47.206903],
						[90.579888, 47.198364],
						[90.653801, 47.111681],
						[90.691989, 47.080717],
						[90.767134, 46.992617],
						[90.830575, 46.995883],
						[90.901408, 46.960768],
						[90.92235, 46.938707],
						[90.929742, 46.893331],
						[90.958075, 46.879425],
						[90.942676, 46.82581],
						[90.992567, 46.790583],
						[90.992567, 46.769682],
						[91.019053, 46.766402],
						[91.054161, 46.717598],
						[91.036299, 46.670393],
						[91.017821, 46.58244],
						[91.068328, 46.579149],
						[91.079415, 46.558989],
						[91.060937, 46.516999],
						[91.038147, 46.500936],
						[91.025828, 46.444057],
						[90.996263, 46.419309],
						[90.983328, 46.374734],
						[90.900177, 46.31235],
						[90.955611, 46.233752],
						[90.94822, 46.219262],
						[90.98456, 46.160431],
						[91.021517, 46.121038],
						[91.014741, 46.06667],
						[91.028292, 46.023054],
						[90.890937, 45.921566],
						[90.799778, 45.834905],
						[90.714779, 45.728895],
						[90.676591, 45.582488],
						[90.671047, 45.487747],
						[90.723402, 45.464667],
						[90.772677, 45.432338],
						[90.773909, 45.405874],
						[90.813329, 45.32851],
						[90.804706, 45.29484],
						[90.831807, 45.300313],
						[90.877387, 45.280946],
						[90.897713, 45.249776],
						[90.866916, 45.209314],
						[90.881698, 45.192025],
						[90.96177, 45.201303],
						[91.007966, 45.218589],
						[91.050466, 45.208892],
						[91.129922, 45.21606],
						[91.17119, 45.199616],
						[91.195827, 45.159118],
						[91.230936, 45.153632],
						[91.242023, 45.13717],
						[91.33503, 45.129571],
						[91.37753, 45.11099],
						[91.429268, 45.156586],
						[91.448978, 45.156586],
						[91.500101, 45.103809],
						[91.561695, 45.075501],
						[91.694738, 45.065357],
						[91.803144, 45.082685],
						[91.885679, 45.078882],
						[92.056911, 45.086911],
						[92.100026, 45.081417],
						[92.240461, 45.015881],
						[92.315605, 45.028994],
						[92.348866, 45.014188],
						[92.414155, 45.018419],
						[92.501003, 45.001072],
						[92.547814, 45.018419],
						[92.683937, 45.02561],
						[92.779407, 45.050561],
						[92.847777, 45.038721],
						[92.884117, 45.046756],
						[92.922921, 45.03703],
						[92.932776, 45.017573],
						[93.002377, 45.009958],
						[93.062124, 45.018419],
						[93.100312, 45.007419],
						[93.174225, 45.015458],
						[93.252449, 44.991761],
						[93.314043, 44.980333],
						[93.314659, 44.995147],
						[93.376869, 44.985412],
						[93.434767, 44.955351],
						[93.509296, 44.968055],
						[93.613389, 44.926546],
						[93.716251, 44.894334],
						[93.723642, 44.865498],
						[94.066105, 44.732154],
						[94.152336, 44.684944],
						[94.215162, 44.667921],
						[94.227481, 44.645785],
						[94.279836, 44.603617],
						[94.329727, 44.582734],
						[94.359292, 44.515775],
						[94.390705, 44.521749],
						[94.470777, 44.509373],
						[94.557008, 44.462408],
						[94.606283, 44.448311],
						[94.673421, 44.397021],
						[94.722696, 44.34055],
						[94.768275, 44.34055],
						[94.826174, 44.320001],
						[94.945666, 44.292592],
						[94.998637, 44.253169],
						[95.1286, 44.269884],
						[95.238853, 44.277169],
						[95.41378, 44.298589],
						[95.43041, 44.281882],
						[95.4107, 44.245024],
						[95.376208, 44.227444],
						[95.355882, 44.166087],
						[95.35157, 44.090054],
						[95.326932, 44.028554],
						[95.377439, 44.025972],
						[95.426099, 44.009618],
						[95.527113, 44.007466],
						[95.623199, 43.855756],
						[95.645373, 43.787966],
						[95.705735, 43.67077],
						[95.735916, 43.597569],
						[95.857872, 43.417436],
						[95.880046, 43.28035],
						[95.921314, 43.229789],
						[96.363558, 42.900562],
						[96.386348, 42.727592],
						[96.742361, 42.75704],
						[96.968411, 42.756161],
						[97.172903, 42.795257],
						[97.28254, 42.782081],
						[97.831958, 42.706047],
						[98.195362, 42.653251],
						[98.546447, 42.638284],
						[98.962822, 42.607018],
						[99.51224, 42.568244],
						[99.969267, 42.647969],
						[100.004376, 42.648849],
						[100.272309, 42.636523],
						[100.32528, 42.690213],
						[100.826655, 42.675255],
						[100.862995, 42.671295],
						[101.291689, 42.586312],
						[101.557775, 42.529887],
						[101.770274, 42.509597],
						[101.803534, 42.503861],
						[101.877447, 42.432345],
						[102.070236, 42.232374],
						[102.093642, 42.223512],
						[102.449039, 42.144133],
						[102.540814, 42.162323],
						[102.621502, 42.154338],
						[102.712045, 42.153007],
						[103.021862, 42.028212],
						[103.20726, 41.96283],
						[103.418527, 41.882233],
						[103.454868, 41.877332],
						[103.868779, 41.802427],
						[104.080046, 41.805104],
						[104.30856, 41.840782],
						[104.418813, 41.860397],
						[104.530298, 41.875104],
						[104.524138, 41.661745],
						[104.68921, 41.6452],
						[104.803775, 41.652355],
						[104.923267, 41.654143],
						[105.009498, 41.583007],
						[105.230621, 41.751103],
						[105.291599, 41.749763],
						[105.385221, 41.797073],
						[105.589713, 41.888471],
						[105.74185, 41.949033],
						[106.01348, 42.032213],
						[106.344855, 42.149457],
						[106.372572, 42.161436],
						[106.612789, 42.241679],
						[106.785867, 42.291281],
						[107.051337, 42.319166],
						[107.271844, 42.364285],
						[107.303872, 42.412465],
						[107.46648, 42.458842],
						[107.501589, 42.456635],
						[107.57427, 42.412907],
						[107.736262, 42.415116],
						[107.939522, 42.403628],
						[107.986949, 42.413349],
						[108.022058, 42.433229],
						[108.089195, 42.436321],
						[108.238252, 42.460167],
						[108.298614, 42.438529],
						[108.532671, 42.442945],
						[108.705134, 42.413349],
						[108.798757, 42.415116],
						[108.845569, 42.395673],
						[108.983539, 42.449128],
						[109.026039, 42.458401],
						[109.291509, 42.435879],
						[109.486761, 42.458842],
						[109.544044, 42.472528],
						[109.683862, 42.558988],
						[109.733753, 42.579262],
						[109.906216, 42.635643],
						[110.108244, 42.642687],
						[110.139657, 42.674815],
						[110.34846, 42.742098],
						[110.437156, 42.781203],
						[110.469801, 42.839156],
						[110.631177, 42.936061],
						[110.689691, 43.02144],
						[110.687227, 43.036314],
						[110.736502, 43.089657],
						[110.769763, 43.099272],
						[110.82027, 43.149067],
						[111.02045, 43.329998],
						[111.069725, 43.357852],
						[111.151029, 43.38004],
						[111.183674, 43.396132],
						[111.354289, 43.436125],
						[111.400485, 43.472618],
						[111.456535, 43.494329],
						[111.564325, 43.490422],
						[111.606209, 43.513863],
						[111.79407, 43.672068],
						[111.891388, 43.6738],
						[111.951135, 43.693275],
						[111.970845, 43.748205],
						[111.959758, 43.823382],
						[111.870447, 43.940279],
						[111.773128, 44.010479],
						[111.702295, 44.034147],
						[111.662875, 44.061247],
						[111.559397, 44.171238],
						[111.541535, 44.206855],
						[111.534144, 44.26217],
						[111.507042, 44.294305],
						[111.428818, 44.319573],
						[111.415883, 44.35724],
						[111.427586, 44.394455],
						[111.478709, 44.488884],
						[111.514434, 44.507666],
						[111.530448, 44.55033],
						[111.569868, 44.57634],
						[111.560629, 44.647062],
						[111.585267, 44.705789],
						[111.624687, 44.778477],
						[111.69244, 44.859983],
						[111.764505, 44.969325],
						[111.903707, 45.052252],
						[112.002874, 45.090713],
						[112.071243, 45.096206],
						[112.113743, 45.072965],
						[112.396459, 45.064512],
						[112.438959, 45.071697],
						[112.540589, 45.001072],
						[112.599719, 44.930783],
						[112.712436, 44.879494],
						[112.850406, 44.840466],
						[112.937869, 44.840042],
						[113.037652, 44.822641],
						[113.11526, 44.799714],
						[113.503918, 44.777628],
						[113.540874, 44.759358],
						[113.631417, 44.745333],
						[113.712105, 44.788247],
						[113.798953, 44.849377],
						[113.861778, 44.863377],
						[113.907358, 44.915104],
						[114.065038, 44.931206],
						[114.116777, 44.957045],
						[114.158045, 44.994301],
						[114.19069, 45.036607],
						[114.313262, 45.107189],
						[114.347139, 45.119436],
						[114.409348, 45.179371],
						[114.459855, 45.21353],
						[114.519602, 45.283893],
						[114.539928, 45.325985],
						[114.551014, 45.387383],
						[114.600906, 45.403773],
						[114.745035, 45.438217],
						[114.920578, 45.386122],
						[114.983404, 45.379397],
						[115.178041, 45.396209],
						[115.36467, 45.392427],
						[115.586408, 45.440317],
						[115.699741, 45.45963],
						[115.864197, 45.572853],
						[115.936878, 45.632727],
						[116.026805, 45.661177],
						[116.035428, 45.685013],
						[116.1155, 45.679577],
						[116.17463, 45.688775],
						[116.217746, 45.72221],
						[116.22329, 45.747273],
						[116.260862, 45.776082],
						[116.286731, 45.775247],
						[116.278108, 45.831152],
						[116.288579, 45.839074],
						[116.243, 45.876169],
						[116.271949, 45.966926],
						[116.414231, 46.133896],
						[116.439484, 46.137628],
						[116.536187, 46.23251],
						[116.573143, 46.258998],
						[116.585462, 46.292504],
						[116.673541, 46.325163],
						[116.745606, 46.327642],
						[116.81336, 46.355737],
						[116.834302, 46.384229],
						[116.876801, 46.375559],
						[117.097308, 46.356976],
						[117.247597, 46.366888],
						[117.372017, 46.36028],
						[117.383719, 46.394962],
						[117.375712, 46.416421],
						[117.392343, 46.463023],
						[117.447777, 46.528117],
						[117.42006, 46.582029],
						[117.49582, 46.600535],
						[117.596218, 46.603414],
						[117.622704, 46.596012],
						[117.641182, 46.558166],
						[117.704008, 46.516587],
						[117.748355, 46.521941],
						[117.769913, 46.537586],
						[117.813645, 46.530588],
						[117.870927, 46.549935],
						[117.868464, 46.575447],
						[117.914659, 46.607936],
						[117.982412, 46.614925],
						[117.992883, 46.631366],
						[118.04647, 46.631366],
						[118.124078, 46.678195],
						[118.192448, 46.682711],
						[118.238643, 46.709392],
						[118.274984, 46.715957],
						[118.316252, 46.73934],
						[118.41049, 46.728265],
						[118.446831, 46.704467],
						[118.586033, 46.692975],
						[118.639004, 46.721291],
						[118.677192, 46.6979],
						[118.788061, 46.687227],
						[118.788061, 46.717598],
						[118.845343, 46.771731],
						[118.914329, 46.77501],
						[118.912481, 46.733188],
						[118.951285, 46.722111],
						[119.011647, 46.745902],
						[119.073857, 46.676552],
						[119.123132, 46.642872],
						[119.152081, 46.658072],
						[119.20074, 46.648213],
						[119.26295, 46.649034],
						[119.325776, 46.608759],
						[119.357805, 46.619447],
						[119.374435, 46.603414],
						[119.431718, 46.638763],
						[119.491464, 46.629311],
						[119.557985, 46.633832],
						[119.598637, 46.618214],
						[119.656535, 46.625612],
						[119.682405, 46.605058],
						[119.677477, 46.584908],
						[119.739687, 46.615336],
						[119.783419, 46.626023],
						[119.8136, 46.66834],
						[119.804361, 46.68189],
						[119.859179, 46.669572],
						[119.911534, 46.669572],
						[119.93494, 46.712674],
						[119.917078, 46.758203],
						[119.936172, 46.790173],
						[119.920157, 46.853238],
						[119.926933, 46.903963],
						[119.859795, 46.917046],
						[119.845013, 46.964852],
						[119.795122, 47.013024],
						[119.79081, 47.04525],
						[119.806825, 47.055037],
						[119.763093, 47.13082],
						[119.716282, 47.195518],
						[119.627586, 47.247544],
						[119.56784, 47.248357],
						[119.559217, 47.303172],
						[119.450812, 47.353065],
						[119.437877, 47.378602],
						[119.386138, 47.397645],
						[119.365812, 47.423161],
						[119.32208, 47.42721],
						[119.365812, 47.47739],
						[119.205052, 47.520249],
						[119.152081, 47.540453],
						[119.134219, 47.664335],
						[118.773278, 47.771034],
						[118.568171, 47.992187],
						[118.441903, 47.995791],
						[118.422193, 48.01461],
						[118.37415, 48.016612],
						[118.351976, 48.006203],
						[118.284839, 48.011007],
						[118.238027, 48.031422],
						[118.238643, 48.041826],
						[118.150564, 48.036224],
						[118.124694, 48.047427],
						[118.107448, 48.031021],
						[118.052014, 48.01421],
						[117.96147, 48.011007],
						[117.886942, 48.025418],
						[117.813645, 48.016212],
						[117.529081, 47.782697],
						[117.519226, 47.761782],
						[117.493357, 47.758563],
						[117.384335, 47.641356],
						[117.094844, 47.8241],
						[116.879265, 47.893968],
						[116.791186, 47.89758],
						[116.669846, 47.890758],
						[116.453035, 47.837358],
						[116.26579, 47.876711],
						[116.130283, 47.823296],
						[116.111189, 47.811642],
						[115.968291, 47.689721],
						[115.939342, 47.683275],
						[115.580249, 47.921649],
						[115.539597, 48.104607],
						[115.545141, 48.134971],
						[115.529126, 48.155336],
						[115.81061, 48.257042],
						[115.822929, 48.259432],
						[115.799523, 48.514982],
						[115.83032, 48.560156],
						[116.069305, 48.811437],
						[116.077928, 48.822471],
						[116.048363, 48.873274],
						[116.428397, 49.430659],
						[116.717889, 49.847288],
						[116.736367, 49.847674],
						[117.068974, 49.695389],
						[117.278394, 49.636512],
						[117.485349, 49.633024],
						[117.638102, 49.574847],
						[117.809333, 49.521263],
						[117.849369, 49.551557],
						[117.866, 49.591532],
						[117.950999, 49.596187],
						[117.995963, 49.623332],
						[118.011362, 49.614803],
						[118.082811, 49.616741],
						[118.129622, 49.669446],
						[118.156723, 49.660149],
						[118.211542, 49.690744],
						[118.220781, 49.729831],
						[118.284223, 49.743755],
						[118.315636, 49.766953],
						[118.384005, 49.783958],
						[118.398787, 49.802502],
						[118.385853, 49.827217],
						[118.443751, 49.835709],
						[118.483787, 49.830691],
						[118.485019, 49.866194],
						[118.531214, 49.887791],
						[118.574946, 49.931342],
						[118.605127, 49.926719],
						[118.672264, 49.955991],
						[118.739402, 49.946364],
						[118.761576, 49.959456],
						[118.791757, 49.955606],
						[118.964836, 49.988708],
						[118.982082, 49.979087],
						[119.090487, 49.985629],
						[119.12498, 50.019095],
						[119.163168, 50.027554],
						[119.193965, 50.069826],
						[119.190269, 50.087877],
						[119.236465, 50.075204],
						[119.290052, 50.121655],
						[119.309762, 50.161161],
						[119.350414, 50.166145],
						[119.339327, 50.192206],
						[119.358421, 50.197953],
						[119.319001, 50.220933],
						[119.339943, 50.244668],
						[119.35103, 50.303953],
						[119.381827, 50.324208],
						[119.358421, 50.358965],
						[119.322696, 50.352474],
						[119.277117, 50.366218],
						[119.259871, 50.345218],
						[119.232153, 50.365455],
						[119.188422, 50.347509],
						[119.155777, 50.364691],
						[119.176719, 50.378814],
						[119.125596, 50.389118],
						[119.165016, 50.422683],
						[119.217371, 50.414675],
						[119.22353, 50.441363],
						[119.250631, 50.448604],
						[119.262334, 50.490124],
						[119.264182, 50.536933],
						[119.295595, 50.573814],
						[119.281428, 50.601551],
						[119.298059, 50.616743],
						[119.361501, 50.632689],
						[119.394145, 50.667219],
						[119.385522, 50.682769],
						[119.430486, 50.684286],
						[119.450196, 50.695281],
						[119.506862, 50.763846],
						[119.496391, 50.771795],
						[119.515485, 50.814165],
						[119.498855, 50.827776],
						[119.491464, 50.87878],
						[119.569688, 50.933879],
						[119.598637, 50.984767],
						[119.630666, 51.00925],
						[119.678093, 51.016404],
						[119.726753, 51.051028],
						[119.719361, 51.075099],
						[119.764325, 51.092017],
						[119.752622, 51.117193],
						[119.771716, 51.124331],
						[119.788346, 51.174636],
						[119.760629, 51.212516],
						[119.784035, 51.22601],
						[119.821607, 51.21439],
						[119.797586, 51.243622],
						[119.828383, 51.263099],
						[119.811136, 51.281071],
						[119.885049, 51.302777],
						[119.883817, 51.336813],
						[119.946643, 51.360736],
						[119.914614, 51.374187],
						[119.910918, 51.390994],
						[119.97128, 51.40033],
						[119.982983, 51.445112],
						[120.002693, 51.459283],
						[119.982367, 51.482396],
						[119.985447, 51.505125],
						[120.017476, 51.52114],
						[120.052584, 51.560967],
						[120.035954, 51.583657],
						[120.05936, 51.634203],
						[120.100628, 51.649058],
						[120.087077, 51.678013],
						[120.172693, 51.679868],
						[120.226279, 51.717703],
						[120.294649, 51.752171],
						[120.317438, 51.785873],
						[120.363634, 51.789945],
						[120.40675, 51.81659],
						[120.40059, 51.833605],
						[120.480046, 51.855049],
						[120.481278, 51.885719],
						[120.549032, 51.882394],
						[120.548416, 51.907877],
						[120.656821, 51.926333],
						[120.66298, 51.958061],
						[120.704864, 51.983501],
						[120.717799, 52.015556],
						[120.691929, 52.026973],
						[120.690698, 52.047221],
						[120.717183, 52.072978],
						[120.753523, 52.085483],
						[120.76769, 52.10938],
						[120.760299, 52.136937],
						[120.786784, 52.15787],
						[120.745516, 52.20594],
						[120.755371, 52.258355],
						[120.715951, 52.261286],
						[120.695625, 52.290214],
						[120.653741, 52.302658],
						[120.627256, 52.323878],
						[120.62356, 52.361172],
						[120.653741, 52.371038],
						[120.64943, 52.3904],
						[120.688234, 52.427637],
						[120.68269, 52.464479],
						[120.706712, 52.492909],
						[120.687002, 52.511489],
						[120.734429, 52.536977],
						[120.690698, 52.547532],
						[120.658669, 52.56718],
						[120.62664, 52.570818],
						[120.605082, 52.589364],
						[120.56135, 52.595544],
						[120.483742, 52.630066],
						[120.462184, 52.64532],
						[120.396895, 52.616261],
						[120.289721, 52.623527],
						[120.194866, 52.578819],
						[120.125265, 52.586819],
						[120.07599, 52.586092],
						[120.049505, 52.598453],
						[120.035338, 52.646409],
						[120.071063, 52.70628],
						[120.031642, 52.773674],
						[120.101244, 52.788877],
						[120.14128, 52.813119],
						[120.181316, 52.806969],
						[120.222584, 52.84277],
						[120.297112, 52.869872],
						[120.295265, 52.891542],
						[120.350699, 52.906343],
						[120.363018, 52.94134],
						[120.411061, 52.957927],
						[120.452945, 53.01017],
						[120.529321, 53.045803],
						[120.562582, 53.082845],
						[120.643886, 53.106923],
						[120.659901, 53.137091],
						[120.687002, 53.142476],
						[120.690698, 53.174771],
						[120.736277, 53.204892],
						[120.821893, 53.241797],
						[120.838523, 53.239648],
						[120.820661, 53.269007],
						[120.867472, 53.278669],
						[120.882871, 53.294411],
						[120.936457, 53.28833],
						[120.950624, 53.29763],
						[121.055334, 53.29155],
						[121.098449, 53.306929],
						[121.129246, 53.277238],
						[121.155732, 53.285468],
						[121.227797, 53.280459],
						[121.308485, 53.301565],
						[121.336818, 53.325877],
						[121.416274, 53.319443],
						[121.499426, 53.337314],
						[121.589969, 53.350891],
						[121.697758, 53.392666],
						[121.754425, 53.389454],
						[121.816019, 53.41336],
						[121.875765, 53.426556],
						[122.026054, 53.428339],
						[122.077177, 53.422277],
						[122.111054, 53.426913],
						[122.161561, 53.468614],
						[122.227466, 53.461845],
						[122.266886, 53.470039],
						[122.350038, 53.505647],
						[122.37406, 53.47467],
						[122.435038, 53.444739],
						[122.496016, 53.458638],
						[122.5379, 53.453293],
						[122.608117, 53.465408],
						[122.673406, 53.459351],
						[122.763949, 53.463626],
						[122.826775, 53.457213],
						[122.894528, 53.462914],
						[122.943804, 53.483929],
						[123.052209, 53.506715],
						[123.093477, 53.508138],
						[123.137209, 53.498172],
						[123.179092, 53.509918],
						[123.231447, 53.549404],
						[123.274563, 53.563269],
						[123.309672, 53.56078],
						[123.394055, 53.538024],
						[123.454417, 53.536602],
						[123.47228, 53.509206],
						[123.499381, 53.497816],
						[123.510468, 53.509206],
						[123.490758, 53.542648],
						[123.517243, 53.558292],
						[123.546808, 53.551537],
						[123.557895, 53.531978],
						[123.53141, 53.507071],
						[123.569598, 53.505291],
						[123.58746, 53.546915],
						[123.620721, 53.550115],
						[123.668764, 53.533756],
						[123.698329, 53.498528],
						[123.746373, 53.500308],
						[123.797495, 53.489983],
						[123.865249, 53.489627],
						[123.985973, 53.434401],
						[124.01369, 53.403371],
						[124.058038, 53.404085],
						[124.125791, 53.348033],
						[124.19416, 53.37339],
						[124.239124, 53.379817],
						[124.327819, 53.331954],
						[124.375863, 53.258984],
						[124.412203, 53.248601],
						[124.435609, 53.223886],
						[124.487348, 53.217436],
						[124.496587, 53.207759],
						[124.563108, 53.201666],
						[124.590209, 53.208476],
						[124.678905, 53.207043],
						[124.720789, 53.192344],
						[124.712165, 53.162574],
						[124.734339, 53.146783],
						[124.787926, 53.140681],
						[124.832889, 53.145347],
						[124.87231, 53.099018],
						[124.909266, 53.118059],
						[124.887708, 53.164368],
						[124.970244, 53.194137],
						[125.038613, 53.202741],
						[125.142091, 53.204175],
						[125.195062, 53.198439],
						[125.252344, 53.18051],
						[125.315786, 53.144989],
						[125.343503, 53.14463],
						[125.452524, 53.107641],
						[125.503647, 53.095424],
						[125.504263, 53.061271],
						[125.530749, 53.0512],
						[125.588647, 53.081047],
						[125.613901, 53.083564],
						[125.640386, 53.06199],
						[125.643466, 53.039686],
						[125.684118, 53.00801],
						[125.742632, 52.993964],
						[125.737088, 52.943504],
						[125.665023, 52.913561],
						[125.666871, 52.869872],
						[125.678574, 52.86084],
						[125.722306, 52.880347],
						[125.751255, 52.88143],
						[125.772197, 52.89804],
						[125.827631, 52.899123],
						[125.854117, 52.891542],
						[125.855349, 52.866259],
						[125.923718, 52.815651],
						[125.937269, 52.786705],
						[125.966834, 52.759914],
						[125.985312, 52.758465],
						[126.02042, 52.795753],
						[126.052449, 52.800095],
						[126.116507, 52.768243],
						[126.112195, 52.757016],
						[126.044442, 52.739628],
						[126.072775, 52.691048],
						[126.061688, 52.673271],
						[125.995783, 52.675085],
						[125.971145, 52.654033],
						[125.968682, 52.630429],
						[125.989008, 52.603178],
						[126.030891, 52.576273],
						[126.055529, 52.582455],
						[126.066616, 52.603905],
						[126.147304, 52.573],
						[126.213209, 52.525327],
						[126.192883, 52.492181],
						[126.205202, 52.466302],
						[126.268644, 52.475051],
						[126.326542, 52.424353],
						[126.353644, 52.389304],
						[126.348716, 52.357882],
						[126.320999, 52.342163],
						[126.327774, 52.310342],
						[126.4331, 52.298632],
						[126.436795, 52.277034],
						[126.401071, 52.279597],
						[126.357955, 52.264216],
						[126.312992, 52.235271],
						[126.306832, 52.205574],
						[126.34502, 52.192002],
						[126.403535, 52.185031],
						[126.457121, 52.165212],
						[126.499005, 52.16044],
						[126.556288, 52.136203],
						[126.563679, 52.119302],
						[126.514404, 52.037282],
						[126.487918, 52.041699],
						[126.450962, 52.027709],
						[126.447882, 52.009294],
						[126.468208, 51.982395],
						[126.462665, 51.948471],
						[126.510092, 51.922274],
						[126.555056, 51.874266],
						[126.580925, 51.824728],
						[126.622809, 51.777357],
						[126.658534, 51.762544],
						[126.6727, 51.73179],
						[126.724439, 51.7266],
						[126.734294, 51.711399],
						[126.723823, 51.679126],
						[126.741069, 51.642374],
						[126.67886, 51.602246],
						[126.69549, 51.57845],
						[126.837156, 51.536033],
						[126.843931, 51.521885],
						[126.812518, 51.493948],
						[126.784185, 51.448095],
						[126.791577, 51.432428],
						[126.835308, 51.413769],
						[126.908605, 51.407423],
						[126.930163, 51.359241],
						[126.904293, 51.340552],
						[126.837156, 51.345038],
						[126.813134, 51.311756],
						[126.820526, 51.281071],
						[126.863025, 51.248492],
						[126.908605, 51.246619],
						[126.92154, 51.259729],
						[126.908605, 51.283691],
						[126.877808, 51.300906],
						[126.887047, 51.321856],
						[126.970815, 51.332327],
						[126.98375, 51.318863],
						[126.976358, 51.291551],
						[126.926467, 51.246244],
						[126.899982, 51.200518],
						[126.917844, 51.138977],
						[126.922772, 51.061937],
						[126.985597, 51.029202],
						[127.052119, 50.962911],
						[127.113713, 50.93765],
						[127.143894, 50.910111],
						[127.236285, 50.781256],
						[127.295415, 50.755139],
						[127.305886, 50.733932],
						[127.28864, 50.699451],
						[127.294799, 50.663426],
						[127.370559, 50.581415],
						[127.36132, 50.547582],
						[127.323132, 50.52552],
						[127.293567, 50.46575],
						[127.30527, 50.45432],
						[127.3644, 50.438314],
						[127.369944, 50.403996],
						[127.332371, 50.340634],
						[127.371791, 50.29669],
						[127.44632, 50.270686],
						[127.603385, 50.239309],
						[127.60708, 50.178794],
						[127.58737, 50.137768],
						[127.501755, 50.056764],
						[127.495595, 49.994479],
						[127.543638, 49.944438],
						[127.547334, 49.928645],
						[127.529472, 49.864265],
						[127.531936, 49.826059],
						[127.583059, 49.786277],
						[127.653892, 49.780094],
						[127.674833, 49.764247],
						[127.677913, 49.697712],
						[127.705015, 49.665185],
						[127.782007, 49.630698],
						[127.815268, 49.593859],
						[127.897804, 49.579116],
						[127.949542, 49.596187],
						[128.001281, 49.592307],
						[128.070882, 49.556604],
						[128.122005, 49.55311],
						[128.185447, 49.53952],
						[128.243345, 49.563203],
						[128.287077, 49.566309],
						[128.343128, 49.544956],
						[128.389939, 49.58998],
						[128.500192, 49.593859],
						[128.537764, 49.604332],
						[128.619684, 49.593471],
						[128.656025, 49.577564],
						[128.715155, 49.564756],
						[128.744104, 49.595023],
						[128.802618, 49.58222],
						[128.813089, 49.558157],
						[128.763198, 49.515824],
						[128.76135, 49.482009],
						[128.792147, 49.473065],
						[128.871604, 49.492506],
						[128.932582, 49.46801],
						[129.013886, 49.457119],
						[129.061929, 49.374189],
						[129.084719, 49.359769],
						[129.143849, 49.357431],
						[129.180805, 49.386657],
						[129.215298, 49.399122],
						[129.266421, 49.396006],
						[129.320623, 49.3586],
						[129.358196, 49.355871],
						[129.379138, 49.367175],
						[129.374826, 49.414309],
						[129.390224, 49.432605],
						[129.448739, 49.441167],
						[129.51834, 49.423652],
						[129.546057, 49.395227],
						[129.562687, 49.299706],
						[129.604571, 49.279018],
						[129.696962, 49.298535],
						[129.730223, 49.288387],
						[129.761636, 49.25754],
						[129.753629, 49.208692],
						[129.784426, 49.184054],
						[129.847867, 49.181316],
						[129.864498, 49.158621],
						[129.855259, 49.133567],
						[129.866962, 49.113985],
						[129.913157, 49.1085],
						[129.934715, 49.078717],
						[129.9187, 49.060681],
						[129.937179, 49.040285],
						[130.020946, 49.021058],
						[130.059135, 48.979047],
						[130.113337, 48.956653],
						[130.219895, 48.893739],
						[130.237757, 48.868551],
						[130.279641, 48.866976],
						[130.412068, 48.905148],
						[130.471198, 48.905541],
						[130.501995, 48.865795],
						[130.559277, 48.861071],
						[130.609168, 48.881146],
						[130.680617, 48.881146],
						[130.689856, 48.849651],
						[130.622103, 48.783842],
						[130.576524, 48.688719],
						[130.538951, 48.635751],
						[130.538335, 48.612016],
						[130.605473, 48.594207],
						[130.615944, 48.575601],
						[130.620871, 48.49595],
						[130.647357, 48.484844],
						[130.711414, 48.511414],
						[130.767465, 48.507846],
						[130.776704, 48.480084],
						[130.745907, 48.449131],
						[130.747755, 48.404256],
						[130.785327, 48.357353],
						[130.81982, 48.341444],
						[130.845073, 48.296473],
						[130.817972, 48.265409],
						[130.787791, 48.256643],
						[130.769313, 48.231136],
						[130.765617, 48.18926],
						[130.673842, 48.12818],
						[130.666451, 48.105007],
						[130.699711, 48.044227],
						[130.737284, 48.034223],
						[130.770544, 47.998194],
						[130.870943, 47.943301],
						[130.891269, 47.927263],
						[130.961486, 47.828118],
						[130.966413, 47.733211],
						[130.983659, 47.713081],
						[131.029855, 47.694555],
						[131.115471, 47.689721],
						[131.183224, 47.702611],
						[131.236811, 47.733211],
						[131.273767, 47.738846],
						[131.359998, 47.730796],
						[131.456085, 47.747297],
						[131.543548, 47.736028],
						[131.559563, 47.724757],
						[131.568186, 47.682469],
						[131.59036, 47.660707],
						[131.641483, 47.663932],
						[131.690142, 47.707041],
						[131.741881, 47.706638],
						[131.825649, 47.677231],
						[131.900793, 47.685692],
						[131.976554, 47.673201],
						[132.000575, 47.712276],
						[132.086191, 47.703013],
						[132.157024, 47.70543],
						[132.19706, 47.714289],
						[132.242639, 47.70986],
						[132.272205, 47.718718],
						[132.288835, 47.742065],
						[132.325175, 47.762184],
						[132.371987, 47.765402],
						[132.469305, 47.726368],
						[132.558, 47.718316],
						[132.6005, 47.740858],
						[132.599268, 47.792347],
						[132.621442, 47.82852],
						[132.662094, 47.854227],
						[132.687348, 47.88514],
						[132.662094, 47.922451],
						[132.661478, 47.944905],
						[132.691043, 47.962941],
						[132.723072, 47.962941],
						[132.769268, 47.93849],
						[132.819159, 47.936887],
						[132.883216, 48.002599],
						[132.992238, 48.035424],
						[133.016259, 48.054228],
						[133.02673, 48.085421],
						[133.053216, 48.110202],
						[133.130208, 48.134971],
						[133.182563, 48.135769],
						[133.239845, 48.126583],
						[133.302055, 48.103009],
						[133.407997, 48.124585],
						[133.451728, 48.112999],
						[133.545967, 48.121389],
						[133.573068, 48.182078],
						[133.59709, 48.194846],
						[133.667307, 48.183275],
						[133.693177, 48.186866],
						[133.740604, 48.254651],
						[133.791111, 48.261026],
						[133.824372, 48.277359],
						[133.876111, 48.282536],
						[133.940784, 48.302047],
						[133.995603, 48.303639],
						[134.029479, 48.327519],
						[134.0689, 48.338659],
						[134.116327, 48.333089],
						[134.150819, 48.346217],
						[134.20379, 48.3824],
						[134.369478, 48.382797],
						[134.438463, 48.405448],
						[134.501905, 48.418954],
						[134.578281, 48.405448],
						[134.696542, 48.407037],
						[134.764295, 48.370076],
						[134.820961, 48.37604],
						[134.848679, 48.393925],
						[134.886867, 48.437618],
						[134.927519, 48.451513],
						[134.996504, 48.439603],
						[135.035924, 48.440795],
						[135.068569, 48.459451],
						[135.09567, 48.437618],
						[135.090743, 48.403461],
						[135.009439, 48.365703],
						[134.864077, 48.332293],
						[134.77107, 48.288908],
						[134.679295, 48.256245],
						[134.67252, 48.170505],
						[134.632484, 48.099412],
						[134.551796, 48.032622],
						[134.55426, 47.982173],
						[134.599839, 47.947711],
						[134.607846, 47.909214],
						[134.658969, 47.901191],
						[134.677448, 47.884738],
						[134.670056, 47.864667],
						[134.678679, 47.819278],
						[134.772918, 47.763391],
						[134.779694, 47.7159],
						[134.689766, 47.63813],
						[134.678064, 47.588507],
						[134.627556, 47.546512],
						[134.576434, 47.519036],
						[134.568426, 47.478199],
						[134.522847, 47.468086],
						[134.490202, 47.446235],
						[134.339297, 47.439759],
						[134.307268, 47.428829],
						[134.266616, 47.391974],
						[134.263536, 47.371307],
						[134.203174, 47.347389],
						[134.177305, 47.326299],
						[134.156979, 47.248357],
						[134.210566, 47.210155],
						[134.230276, 47.182097],
						[134.232739, 47.134892],
						[134.222268, 47.105164],
						[134.142812, 47.093349],
						[134.118175, 47.061968],
						[134.10216, 47.005678],
						[134.063972, 46.979962],
						[134.076291, 46.938298],
						[134.042414, 46.886787],
						[134.041182, 46.848326],
						[134.025168, 46.810657],
						[134.052885, 46.779928],
						[134.033175, 46.759023],
						[134.030711, 46.708981],
						[134.011001, 46.637941],
						[133.919842, 46.596012],
						[133.890893, 46.525235],
						[133.849625, 46.475389],
						[133.852089, 46.450242],
						[133.902596, 46.446119],
						[133.948791, 46.401153],
						[133.940784, 46.38134],
						[133.876726, 46.362345],
						[133.869335, 46.338386],
						[133.922922, 46.330948],
						[133.908139, 46.308216],
						[133.91861, 46.280924],
						[133.909987, 46.254447],
						[133.867487, 46.250722],
						[133.87919, 46.233752],
						[133.849625, 46.203939],
						[133.814517, 46.230854],
						[133.794807, 46.193583],
						[133.764626, 46.17328],
						[133.706111, 46.163333],
						[133.690713, 46.133896],
						[133.745531, 46.075389],
						[133.740604, 46.048812],
						[133.681474, 45.986473],
						[133.676546, 45.94321],
						[133.614952, 45.942794],
						[133.618032, 45.903662],
						[133.583539, 45.868669],
						[133.55459, 45.893249],
						[133.51209, 45.887001],
						[133.491764, 45.867002],
						[133.494228, 45.840325],
						[133.467743, 45.834905],
						[133.469591, 45.799451],
						[133.505315, 45.785681],
						[133.469591, 45.777751],
						[133.486837, 45.740173],
						[133.454192, 45.731819],
						[133.445569, 45.705077],
						[133.484989, 45.691702],
						[133.485605, 45.658667],
						[133.448649, 45.647372],
						[133.471438, 45.631053],
						[133.412924, 45.618079],
						[133.423395, 45.584163],
						[133.393214, 45.580393],
						[133.342707, 45.554836],
						[133.333468, 45.562379],
						[133.246005, 45.517528],
						[133.201657, 45.515431],
						[133.170244, 45.465506],
						[133.164701, 45.437377],
						[133.143759, 45.430658],
						[133.144991, 45.367205],
						[133.119121, 45.352908],
						[133.128976, 45.336924],
						[133.097563, 45.281788],
						[133.109266, 45.232077],
						[133.124665, 45.222805],
						[133.137599, 45.178105],
						[133.139447, 45.127459],
						[133.107418, 45.124504],
						[133.089556, 45.097473],
						[133.070462, 45.097051],
						[133.045824, 45.066203],
						[132.986078, 45.031109],
						[132.954049, 45.023072],
						[132.916477, 45.031109],
						[132.867202, 45.061976],
						[132.76434, 45.081417],
						[132.394161, 45.16376],
						[132.17427, 45.216903],
						[132.003655, 45.25441],
						[131.976554, 45.277156],
						[131.93159, 45.287683],
						[131.917423, 45.339448],
						[131.887858, 45.342393],
						[131.82996, 45.311677],
						[131.825649, 45.291472],
						[131.788692, 45.245984],
						[131.79362, 45.211844],
						[131.759127, 45.213952],
						[131.721555, 45.234606],
						[131.681519, 45.215217],
						[131.650722, 45.159962],
						[131.687678, 45.1511],
						[131.695685, 45.132104],
						[131.63286, 45.075078],
						[131.566338, 45.045487],
						[131.529382, 45.012073],
						[131.484418, 44.99557],
						[131.501664, 44.977793],
						[131.464708, 44.963397],
						[131.409889, 44.985836],
						[131.380324, 44.978216],
						[131.355071, 44.990068],
						[131.313803, 44.965938],
						[131.311955, 44.94688],
						[131.274999, 44.919766],
						[131.263296, 44.929935],
						[131.207861, 44.913833],
						[131.20355, 44.932901],
						[131.16105, 44.948151],
						[131.090217, 44.924427],
						[131.10192, 44.898997],
						[131.07913, 44.881614],
						[130.965181, 44.85065],
						[130.972573, 44.820094],
						[131.016304, 44.814575],
						[131.016304, 44.789521],
						[131.064348, 44.786973],
						[131.069275, 44.759783],
						[131.093297, 44.746183],
						[131.090833, 44.717272],
						[131.111775, 44.710042],
						[131.310723, 44.046623],
						[131.26576, 44.034578],
						[131.245434, 43.95579],
						[131.26268, 43.948897],
						[131.254057, 43.893289],
						[131.2171, 43.836334],
						[131.213405, 43.801357],
						[131.232499, 43.742585],
						[131.215869, 43.72745],
						[131.221412, 43.682024],
						[131.239274, 43.670337],
						[131.216485, 43.613169],
						[131.222028, 43.593234],
						[131.20047, 43.532089],
						[131.276847, 43.495632],
						[131.304564, 43.502144],
						[131.31873, 43.499539],
						[131.314419, 43.461325],
						[131.295941, 43.441774],
						[131.314419, 43.392653],
						[131.275615, 43.369165],
						[131.269455, 43.297775],
						[131.255289, 43.265099],
						[131.206014, 43.237202],
						[131.201086, 43.203185],
						[131.218948, 43.191405],
						[131.207861, 43.1316],
						[131.173985, 43.111506],
						[131.171521, 43.06955],
						[131.120398, 43.068238],
						[131.102536, 43.021002],
						[131.11855, 43.007875],
						[131.115471, 42.975482],
						[131.151195, 42.968475],
						[131.14442, 42.939566],
						[131.114855, 42.915027],
						[131.034167, 42.929051],
						[131.017536, 42.915027],
						[131.045869, 42.866796],
						[130.981812, 42.857145],
						[130.949783, 42.876884],
						[130.890653, 42.852758],
						[130.845073, 42.881269],
						[130.801957, 42.879515],
						[130.784095, 42.842227],
						[130.75453, 42.845738],
						[130.719422, 42.831695],
						[130.708335, 42.846615],
						[130.665835, 42.847932],
						[130.603625, 42.819405],
						[130.562357, 42.815015],
						[130.532792, 42.787352],
						[130.46627, 42.772417],
						[130.40714, 42.731548],
						[130.425003, 42.706926],
						[130.464423, 42.688453],
						[130.529096, 42.703408],
						[130.592538, 42.671295],
						[130.633806, 42.603494],
						[130.622719, 42.573092],
						[130.570364, 42.557224],
						[130.565437, 42.506509],
						[130.599929, 42.486211],
						[130.600545, 42.450453],
						[130.645509, 42.426603],
						[130.581451, 42.435437],
						[130.585763, 42.485328],
						[130.558661, 42.495919],
						[130.556198, 42.523712],
						[130.520473, 42.583228],
						[130.522937, 42.622433],
						[130.482285, 42.626837],
						[130.459495, 42.588075],
						[130.476125, 42.570007],
						[130.435474, 42.553257],
						[130.423771, 42.574855],
						[130.44656, 42.607459],
						[130.420691, 42.617148],
						[130.388046, 42.603054],
						[130.373264, 42.630799],
						[130.333228, 42.64973],
						[130.290112, 42.702968],
						[130.257467, 42.710884],
						[130.242069, 42.738582],
						[130.245148, 42.799209],
						[130.258083, 42.860655],
						[130.277793, 42.892232],
						[130.258083, 42.90626],
						[130.21004, 42.902315],
						[130.17062, 42.912397],
						[130.136127, 42.90363],
						[130.10225, 42.922916],
						[130.127504, 42.932556],
						[130.120729, 42.954461],
						[130.144134, 42.976357],
						[130.10841, 42.989929],
						[130.072685, 42.971541],
						[130.027106, 42.9676],
						[130.002468, 42.981174],
						[129.963664, 42.978547],
						[129.954425, 43.010938],
						[129.897143, 43.001748],
						[129.903918, 42.968475],
						[129.868193, 42.97373],
						[129.856491, 42.951833],
						[129.874969, 42.923792],
						[129.846636, 42.918533],
						[129.835549, 42.866796],
						[129.816454, 42.851003],
						[129.810911, 42.795257],
						[129.78381, 42.762752],
						[129.767179, 42.707806],
						[129.796744, 42.681854],
						[129.754245, 42.645768],
						[129.786889, 42.615387],
						[129.746237, 42.58455],
						[129.749933, 42.546644],
						[129.738846, 42.500332],
						[129.748701, 42.471204],
						[129.704354, 42.427045],
						[129.643991, 42.43102],
						[129.624281, 42.459284],
						[129.60026, 42.41114],
						[129.546057, 42.361632],
						[129.49863, 42.412023],
						[129.452434, 42.441179],
						[129.400695, 42.449128],
						[129.368051, 42.425719],
						[129.376058, 42.447803],
						[129.344029, 42.451777],
						[129.356348, 42.427045],
						[129.331094, 42.429695],
						[129.30892, 42.403628],
						[129.326167, 42.389927],
						[129.240551, 42.376223],
						[129.231312, 42.356325],
						[129.260261, 42.335536],
						[129.208522, 42.293052],
						[129.231312, 42.283755],
						[129.215914, 42.265157],
						[129.183269, 42.262056],
						[129.181421, 42.242122],
						[129.209138, 42.237692],
						[129.215914, 42.208442],
						[129.166639, 42.188047],
						[129.113668, 42.140583],
						[129.048378, 42.137476],
						[129.039139, 42.107736],
						[129.008958, 42.09175],
						[128.971386, 42.097079],
						[128.954755, 42.083756],
						[128.952908, 42.025545],
						[128.898089, 42.016653],
						[128.795227, 42.042436],
						[128.779213, 42.033546],
						[128.737945, 42.050435],
						[128.70222, 42.02021],
						[128.658489, 42.018876],
						[128.637547, 42.035324],
						[128.60675, 42.02999],
						[128.598127, 42.007315],
						[128.49896, 42.000644],
						[128.466316, 42.020654],
						[128.405338, 42.018876],
						[128.294468, 42.026434],
						[128.090593, 42.022877],
						[128.033926, 42.000199],
						[128.106607, 41.949923],
						[128.115846, 41.896935],
						[128.104143, 41.843457],
						[128.112766, 41.793504],
						[128.147875, 41.78101],
						[128.163889, 41.721628],
						[128.208853, 41.688565],
						[128.248889, 41.681414],
						[128.30186, 41.627756],
						[128.317874, 41.575844],
						[128.301244, 41.544498],
						[128.238418, 41.497898],
						[128.243345, 41.477276],
						[128.203925, 41.410882],
						[128.169433, 41.404149],
						[128.114614, 41.364186],
						[128.090593, 41.374516],
						[128.110919, 41.393375],
						[128.040085, 41.393375],
						[128.000049, 41.442741],
						[127.991426, 41.421204],
						[127.970484, 41.438704],
						[127.93168, 41.444984],
						[127.909506, 41.42973],
						[127.882405, 41.448124],
						[127.86947, 41.4037],
						[127.854688, 41.420755],
						[127.780159, 41.427038],
						[127.684073, 41.422999],
						[127.636645, 41.413575],
						[127.618783, 41.432871],
						[127.563964, 41.432871],
						[127.547334, 41.477276],
						[127.526392, 41.467859],
						[127.465414, 41.479069],
						[127.459255, 41.461581],
						[127.419835, 41.460235],
						[127.405668, 41.478621],
						[127.360088, 41.479518],
						[127.360704, 41.466065],
						[127.296031, 41.486243],
						[127.253531, 41.486691],
						[127.28864, 41.501932],
						[127.241212, 41.520754],
						[127.188241, 41.527475],
						[127.164836, 41.542706],
						[127.14143, 41.530163],
						[127.125416, 41.566442],
						[127.178386, 41.600015],
						[127.135887, 41.600463],
						[127.127263, 41.622388],
						[127.093387, 41.629993],
						[127.103242, 41.647883],
						[127.037952, 41.676944],
						[127.057662, 41.703758],
						[127.050887, 41.744852],
						[127.005923, 41.749317],
						[126.979438, 41.776993],
						[126.940018, 41.773423],
						[126.952953, 41.804212],
						[126.931395, 41.812687],
						[126.861178, 41.768067],
						[126.83962, 41.727435],
						[126.809439, 41.749317],
						[126.8002, 41.702865],
						[126.723207, 41.753335],
						[126.694874, 41.751103],
						[126.690562, 41.728328],
						[126.724439, 41.710907],
						[126.688099, 41.674262],
						[126.644983, 41.661297],
						[126.608027, 41.669345],
						[126.592628, 41.624624],
						[126.564295, 41.608965],
						[126.582773, 41.563307],
						[126.559983, 41.548081],
						[126.497158, 41.406842],
						[126.539041, 41.366881],
						[126.524259, 41.349362],
						[126.497158, 41.374965],
						[126.437411, 41.353405],
						[126.373354, 41.289133],
						[126.35426, 41.244599],
						[126.332086, 41.236949],
						[126.295129, 41.171661],
						[126.188572, 41.114875],
						[126.187956, 41.113072],
						[126.16763, 41.094583],
						[126.124514, 41.092327],
						[126.133753, 41.063906],
						[126.099877, 41.036376],
						[126.1085, 41.011995],
						[126.066, 40.997542],
						[126.08263, 40.976762],
						[126.051833, 40.96185],
						[126.041362, 40.928851],
						[126.008102, 40.936537],
						[125.959442, 40.88181],
						[125.921254, 40.882715],
						[125.875059, 40.908501],
						[125.860892, 40.888597],
						[125.817161, 40.866877],
						[125.778356, 40.897645],
						[125.707523, 40.866877],
						[125.648393, 40.826133],
						[125.641002, 40.798503],
						[125.67611, 40.788082],
						[125.685349, 40.769048],
						[125.61698, 40.763609],
						[125.585567, 40.788535],
						[125.551075, 40.761796],
						[125.544915, 40.729605],
						[125.49564, 40.728697],
						[125.459916, 40.707379],
						[125.453756, 40.676522],
						[125.418648, 40.673345],
						[125.422343, 40.635661],
						[125.375532, 40.658365],
						[125.329337, 40.643835],
						[125.305315, 40.661089],
						[125.279445, 40.655187],
						[125.262815, 40.620218],
						[125.181511, 40.611132],
						[125.113758, 40.569322],
						[125.076801, 40.562048],
						[125.015823, 40.533853],
						[125.004737, 40.496091],
						[125.042925, 40.483802],
						[125.044157, 40.466503],
						[124.985642, 40.475153],
						[124.945606, 40.45603],
						[124.913578, 40.481981],
						[124.834121, 40.423235],
						[124.739267, 40.371733],
						[124.722636, 40.321561],
						[124.62655, 40.291896],
						[124.513833, 40.22019],
						[124.490427, 40.18408],
						[124.457782, 40.177679],
						[124.428217, 40.144291],
						[124.346913, 40.079756],
						[124.336442, 40.049985],
						[124.372167, 40.021576],
						[124.349377, 39.989029],
						[124.288399, 39.962888],
						[124.286551, 39.931689],
						[124.241588, 39.928477],
						[124.216334, 39.89313],
						[124.214486, 39.865116],
						[124.173218, 39.841225],
						[124.151045, 39.74558],
						[124.099306, 39.777323],
						[124.103001, 39.823302],
						[124.002603, 39.800316],
						[123.95148, 39.817786],
						[123.812278, 39.831115],
						[123.795032, 39.822842],
						[123.687858, 39.808132],
						[123.674924, 39.826979],
						[123.645358, 39.823761],
						[123.642279, 39.796178],
						[123.612714, 39.775023],
						[123.579453, 39.781002],
						[123.546808, 39.756163],
						[123.536337, 39.788361],
						[123.484598, 39.763063],
						[123.477823, 39.74696],
						[123.392823, 39.723949],
						[123.388512, 39.74742]
					]
				],
				[
					[
						[114.031778, 22.503923],
						[114.082285, 22.512216],
						[114.095219, 22.534329],
						[114.156813, 22.543726],
						[114.166052, 22.559201],
						[114.222719, 22.553122],
						[114.232574, 22.539857],
						[114.232574, 22.528801],
						[114.260291, 22.547595],
						[114.263371, 22.541515],
						[114.263987, 22.541515],
						[114.28924, 22.52272],
						[114.309566, 22.497288],
						[114.340979, 22.50337],
						[114.2529, 22.445304],
						[114.23319, 22.466875],
						[114.205473, 22.449729],
						[114.220255, 22.427603],
						[114.278769, 22.435901],
						[114.325581, 22.479041],
						[114.376088, 22.436454],
						[114.406269, 22.433688],
						[114.406269, 22.432582],
						[114.385327, 22.41156],
						[114.394566, 22.361757],
						[114.356994, 22.340171],
						[114.323733, 22.384447],
						[114.323733, 22.385001],
						[114.323117, 22.385554],
						[114.322501, 22.385554],
						[114.283081, 22.386661],
						[114.278153, 22.328546],
						[114.315726, 22.299756],
						[114.315726, 22.299203],
						[114.313262, 22.264315],
						[114.284929, 22.263761],
						[114.262139, 22.294773],
						[114.248588, 22.274837],
						[114.265835, 22.200608],
						[114.203009, 22.206703],
						[114.200545, 22.232188],
						[114.164821, 22.226648],
						[114.120473, 22.272068],
						[114.145726, 22.300864],
						[114.121089, 22.320795],
						[114.069966, 22.326885],
						[114.034857, 22.300864],
						[114.029314, 22.262653],
						[114.004676, 22.239389],
						[114.026234, 22.229418],
						[113.996669, 22.206149],
						[113.981271, 22.229972],
						[113.935691, 22.205041],
						[113.899351, 22.215568],
						[113.852539, 22.191188],
						[113.8433, 22.229418],
						[113.889496, 22.271514],
						[113.898119, 22.308615],
						[113.969568, 22.321349],
						[113.955401, 22.298649],
						[114.026234, 22.34792],
						[113.980039, 22.366185],
						[113.941235, 22.355116],
						[113.920293, 22.367845],
						[113.918445, 22.418199],
						[113.977575, 22.45692],
						[114.000981, 22.491206],
						[114.031778, 22.503923]
					]
				],
				[
					[
						[122.673406, 39.269531],
						[122.67895, 39.268605],
						[122.57732, 39.269994],
						[122.497248, 39.300566],
						[122.540979, 39.308439],
						[122.593334, 39.278334],
						[122.641993, 39.288061],
						[122.673406, 39.269531]
					]
				],
				[
					[
						[122.335256, 39.149894],
						[122.316161, 39.185157],
						[122.343263, 39.203246],
						[122.393154, 39.213448],
						[122.383299, 39.190723],
						[122.398697, 39.16196],
						[122.366053, 39.174951],
						[122.335256, 39.149894]
					]
				],
				[
					[
						[122.691884, 39.23292],
						[122.691268, 39.23431],
						[122.690037, 39.234774],
						[122.628443, 39.231993],
						[122.635834, 39.241727],
						[122.740544, 39.248679],
						[122.751631, 39.229675],
						[122.696812, 39.206492],
						[122.691884, 39.23292]
					]
				],
				[
					[
						[122.759022, 39.025404],
						[122.732536, 39.013779],
						[122.704819, 39.044463],
						[122.725145, 39.048181],
						[122.759022, 39.025404]
					]
				],
				[
					[
						[110.106396, 20.026812],
						[110.144585, 20.074598],
						[110.243135, 20.077408],
						[110.28933, 20.056047],
						[110.318279, 20.108882],
						[110.387265, 20.113378],
						[110.495054, 20.077408],
						[110.526467, 20.07516],
						[110.562191, 20.110006],
						[110.655814, 20.134169],
						[110.687843, 20.163947],
						[110.717408, 20.148778],
						[110.744509, 20.074036],
						[110.778386, 20.068415],
						[110.808567, 20.035808],
						[110.871393, 20.01163],
						[110.940994, 20.028499],
						[110.966248, 20.018377],
						[111.013675, 19.850159],
						[111.043856, 19.763448],
						[111.071573, 19.628784],
						[111.061718, 19.612436],
						[111.008747, 19.60398],
						[110.920668, 19.552668],
						[110.888023, 19.518827],
						[110.844292, 19.449996],
						[110.787009, 19.399765],
						[110.729727, 19.378878],
						[110.706321, 19.320153],
						[110.676756, 19.286264],
						[110.619474, 19.152334],
						[110.585597, 18.88075],
						[110.590525, 18.838841],
						[110.578206, 18.784458],
						[110.499366, 18.751592],
						[110.499366, 18.651824],
						[110.367555, 18.631977],
						[110.329366, 18.642185],
						[110.246215, 18.609859],
						[110.214186, 18.578662],
						[110.116867, 18.506602],
						[110.090382, 18.399309],
						[110.070672, 18.376025],
						[110.022629, 18.360121],
						[109.919767, 18.375457],
						[109.785492, 18.339672],
						[109.749767, 18.193618],
						[109.726362, 18.177698],
						[109.661688, 18.175424],
						[109.584696, 18.143579],
						[109.527413, 18.169169],
						[109.467051, 18.173718],
						[109.441182, 18.199303],
						[109.355566, 18.215221],
						[109.287813, 18.264671],
						[109.17448, 18.260125],
						[109.138756, 18.268081],
						[109.108575, 18.323766],
						[109.006329, 18.323198],
						[108.944735, 18.314107],
						[108.905315, 18.389087],
						[108.881293, 18.416344],
						[108.776583, 18.441894],
						[108.68912, 18.447571],
						[108.644772, 18.486738],
						[108.641077, 18.565614],
						[108.663866, 18.67337],
						[108.65278, 18.740258],
						[108.593033, 18.809386],
						[108.595497, 18.872256],
						[108.637997, 18.924346],
						[108.630606, 19.003017],
						[108.598577, 19.055633],
						[108.591186, 19.141592],
						[108.609048, 19.276661],
						[108.644772, 19.349518],
						[108.694047, 19.387346],
						[108.765496, 19.400894],
						[108.806148, 19.450561],
						[108.855424, 19.469182],
						[108.92872, 19.524468],
						[108.993394, 19.587065],
						[109.048829, 19.619764],
						[109.093792, 19.68965],
						[109.147379, 19.704863],
						[109.169553, 19.736411],
						[109.159082, 19.79048],
						[109.231147, 19.863105],
						[109.255784, 19.867045],
						[109.25948, 19.898561],
						[109.300748, 19.917693],
						[109.349407, 19.898561],
						[109.411001, 19.895184],
						[109.498464, 19.873236],
						[109.526797, 19.943573],
						[109.585312, 19.98801],
						[109.657993, 20.01163],
						[109.712195, 20.017253],
						[109.76147, 19.981261],
						[109.814441, 19.993072],
						[109.855093, 19.984073],
						[109.898825, 19.994196],
						[109.965346, 19.993634],
						[109.997375, 19.980136],
						[110.042339, 19.991384],
						[110.106396, 20.026812]
					]
				],
				[
					[
						[120.443706, 22.441432],
						[120.297112, 22.531565],
						[120.274323, 22.560307],
						[120.20041, 22.721039],
						[120.149287, 22.896468],
						[120.133272, 23.000625],
						[120.029795, 23.048544],
						[120.018708, 23.073322],
						[120.081534, 23.291728],
						[120.108019, 23.341191],
						[120.12157, 23.504836],
						[120.095084, 23.58768],
						[120.102476, 23.701162],
						[120.175156, 23.807427],
						[120.245989, 23.840276],
						[120.278018, 23.92783],
						[120.316206, 23.984708],
						[120.391967, 24.118055],
						[120.451713, 24.182493],
						[120.470807, 24.242533],
						[120.520698, 24.311816],
						[120.546568, 24.370159],
						[120.589068, 24.43229],
						[120.642654, 24.490033],
						[120.68885, 24.600542],
						[120.762147, 24.658208],
						[120.82374, 24.688118],
						[120.89211, 24.767482],
						[120.914899, 24.864715],
						[120.961095, 24.940167],
						[121.009754, 24.993878],
						[121.024537, 25.040517],
						[121.102145, 25.075214],
						[121.132942, 25.078466],
						[121.209318, 25.12724],
						[121.319572, 25.140785],
						[121.371926, 25.159746],
						[121.413194, 25.238806],
						[121.444607, 25.27074],
						[121.53515, 25.307535],
						[121.585041, 25.309159],
						[121.62323, 25.29455],
						[121.655259, 25.242054],
						[121.700222, 25.226896],
						[121.707613, 25.191701],
						[121.745186, 25.161912],
						[121.782142, 25.160287],
						[121.841888, 25.135367],
						[121.917033, 25.138076],
						[121.947214, 25.031841],
						[121.98109, 25.030757],
						[122.012503, 25.001471],
						[121.933047, 24.938539],
						[121.844968, 24.836476],
						[121.841272, 24.734329],
						[121.86283, 24.671261],
						[121.892395, 24.617953],
						[121.88562, 24.529784],
						[121.867758, 24.47914],
						[121.82649, 24.423572],
						[121.809243, 24.339083],
						[121.689135, 24.174303],
						[121.678048, 24.133895],
						[121.643556, 24.097843],
						[121.63986, 24.064514],
						[121.65957, 24.007125],
						[121.621382, 23.920718],
						[121.587505, 23.760878],
						[121.522832, 23.538858],
						[121.5216, 23.483431],
						[121.497578, 23.419744],
						[121.479716, 23.322507],
						[121.440296, 23.271937],
						[121.415042, 23.196047],
						[121.430441, 23.137175],
						[121.409499, 23.1025],
						[121.370695, 23.084334],
						[121.35468, 23.00999],
						[121.324499, 22.945526],
						[121.276456, 22.877171],
						[121.237652, 22.836362],
						[121.21055, 22.770711],
						[121.170514, 22.723247],
						[121.078739, 22.669691],
						[121.03316, 22.650914],
						[121.014682, 22.584069],
						[120.981421, 22.528248],
						[120.914899, 22.302525],
						[120.903197, 22.12634],
						[120.912436, 22.086418],
						[120.907508, 22.033171],
						[120.86624, 21.984345],
						[120.873016, 21.897191],
						[120.854537, 21.883309],
						[120.781857, 21.923843],
						[120.743052, 21.915515],
						[120.701784, 21.927174],
						[120.667908, 21.983235],
						[120.651277, 22.033171],
						[120.661748, 22.067007],
						[120.659285, 22.154056],
						[120.640806, 22.241605],
						[120.569973, 22.361757],
						[120.517619, 22.408793],
						[120.443706, 22.441432]
					]
				],
				[
					[
						[117.145351, 23.455983],
						[117.142887, 23.400522],
						[117.124409, 23.389537],
						[117.081909, 23.409309],
						[117.050496, 23.400522],
						[117.027091, 23.41535],
						[116.946402, 23.42194],
						[116.944555, 23.440061],
						[116.982743, 23.460924],
						[117.022779, 23.436767],
						[117.058503, 23.47355],
						[117.093612, 23.459277],
						[117.129336, 23.483431],
						[117.145351, 23.455983]
					]
				],
				[
					[
						[122.163408, 29.988137],
						[122.118445, 29.986582],
						[122.106742, 30.005759],
						[122.027902, 29.991247],
						[121.978011, 30.059125],
						[121.989714, 30.077252],
						[121.983554, 30.100554],
						[121.934895, 30.161631],
						[121.955221, 30.183878],
						[122.048844, 30.147141],
						[122.095655, 30.158008],
						[122.152938, 30.113497],
						[122.293988, 30.100554],
						[122.288444, 30.073109],
						[122.310002, 30.039958],
						[122.343879, 30.020269],
						[122.341415, 29.976733],
						[122.322321, 29.940438],
						[122.279205, 29.937326],
						[122.239785, 29.962735],
						[122.163408, 29.988137]
					]
				],
				[
					[
						[118.412338, 24.514538],
						[118.451758, 24.506915],
						[118.477012, 24.437738],
						[118.457918, 24.412128],
						[118.405563, 24.427931],
						[118.353208, 24.415398],
						[118.329802, 24.382152],
						[118.282375, 24.413218],
						[118.31194, 24.424661],
						[118.298389, 24.477506],
						[118.318715, 24.486765],
						[118.374766, 24.458986],
						[118.412338, 24.514538]
					]
				],
				[
					[
						[122.213915, 30.186464],
						[122.168336, 30.138343],
						[122.143698, 30.163183],
						[122.152938, 30.19112],
						[122.178807, 30.199396],
						[122.213915, 30.186464]
					]
				],
				[
					[
						[122.229314, 29.711995],
						[122.231162, 29.710435],
						[122.269966, 29.685482],
						[122.210836, 29.700559],
						[122.229314, 29.711995]
					]
				],
				[
					[
						[122.427646, 30.738422],
						[122.445509, 30.745109],
						[122.475074, 30.714243],
						[122.528045, 30.725047],
						[122.532972, 30.696748],
						[122.427031, 30.697777],
						[122.427646, 30.738422]
					]
				],






			]
		}
	}]
}
